webpackJsonp([1],{

/***/ "5UXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aCn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7bK5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J4AD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f86d1c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("7bK5")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-9f86d1c4"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2f03a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("5UXz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdf4d00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("5aCn")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fb5dd8a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WAN5")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45475472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("HXhP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a4c432","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("RkWL")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a0b1688","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("J4AD")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a87b78e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("q5L0")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Olympic Review - Issue 120",
  "shortTitle": "",
  "description": "",
  "width": 719,
  "height": 890,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://olympicreview.touchlines.com/120"
  }, {
    "code": "FR",
    "text": "French",
    "href": "http://revueolympique.touchlines.com/120"
  }],
  "basePath": "/120",
  // "basePath": "",
  "companyLogo": "1-logo-1.png",
  "publishURL": "http://olympic-review.s3-website-eu-west-1.amazonaws.com/120/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 1-head\" style=\"top:4px;left:1px\" src=\"/120/static/_content/1-title-1.png\"/>\n        <img class=\"halfScale 1-title\" style=\"top:155px;left:255px\" src=\"/120/static/_content/1-title-2.png\"/>\n        <img class=\"halfScale 1-title\" style=\"top:15px;left:240px\" src=\"/120/static/_content/1-title-3.png\"/>\n        <img class=\"halfScale 1-title\" style=\"top:162px;left:532px\" src=\"/120/static/_content/1-title-4.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:260px;left:234px\" src=\"/120/static/_content/1-sub-1.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:308px;left:244px\" src=\"/120/static/_content/1-sub-2.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:374px;left:211px\" src=\"/120/static/_content/1-sub-3.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:374px;left:394px\" src=\"/120/static/_content/1-sub-4.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:374px;left:534px\" src=\"/120/static/_content/1-sub-5.png\"/>\n        <img id=\"1-logo-1\" class=\"halfScaleC\" style=\"top:812px;left:-27px\" src=\"/120/static/_content/1-logo-1.png\"/>\n        <img class=\"halfScale 1-link\" style=\"top:864px;left:634px\" src=\"/120/static/_content/1-link-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:860px;left:626px;height:16px;width:82px;\">\n          <a href=\"https://olympics.com/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim\n            .fromTo(cOf(\"1-head\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n            .staggerFromTo(cOf(\"1-title\"), 0.6, {opacity:0, y:50},{opacity:1, y:0, ease: Power2.easeOut}, 0.3, 1.3)\n            .staggerFromTo(cOf(\"1-sub\"), 0.4, {opacity:0, x:30},{opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1.9)\n            .fromTo(idOf(\"1-logo-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\", 1)\n            .fromTo(cOf(\"1-link\"), 0.6, {opacity:0, x:-40},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 3.6)\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n        removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Official Publication of the Olympic Movement  REVIEW  July 2023 Number 120  Paris – then and now With one year until the Olympic and Paralympic Games Paris 2024, organisers are blending tradition with innovation  Rewinding the clock 100 years to Paris 1924 and how it laid the foundations for Olympic traditions  A look at the long path to gender equality for women in sport  Different views on Paris 2024 as the city prepares to host the Summer Games for the third time  olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THANKS TO OUR WORLDWIDE OLYMPIC PARTNERS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <img id=\"4-title-1\" class=\"halfScale\" style=\"top:114px;left:43px\" src=\"/120/static/_content/4-title-1.png\"/>\n        <img id=\"4-sub-1\" class=\"halfScale\" style=\"top:178px;left:43px\" src=\"/120/static/_content/4-sub-1.png\"/>\n\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(6)\" style=\"top:369px;left:51px;width:83px;height:90px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(8)\" style=\"top:693px;left:49px;width:103px;height:114px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(12)\" style=\"top:312px;left:343px;width:111px;height:127px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(14)\" style=\"top:712px;left:267px;width:308px;height:111px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(36)\" style=\"top:335px;left:506px;width:141px;height:103px\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.fromTo(idOf(\"4-title-1\"), 0.8, {opacity:0, y:-40},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"4-sub-1\"), 0.4, {opacity:0, x:-40},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        removeContentLinks();\n      }\n      ",
    "searchText": "4  Contents  contents  offIcIal publIcatIon of the olympIc movement july 2023  6  foreword  By IOC President Thomas Bach.  8  henry kIssInger  Olympic Review pays tribute to the IOC Honour Member on his 100th birthday.  12  beyond the rIngs  We should strive for all athletes to be allowed to participate in competitions, says Karl Friedrich Wessel.  14 parIs 1924  36  then and now  Explore a century of Paris’s Olympic landscape with maps of the 1924 and 2024 Games.  In a series of opinion pieces by writers from outside the Olympic Movement, Thierry Terret considers how Paris 1924 marked a turning point in Olympic history; George Hirthler looks at how the Games delivered a fitting swansong for Pierre de Coubertin; and Florence Carpentier retraces the birth and growth of women’s sport."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(40)\" style=\"top:155px;left:181px;width:89px;height:125px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(42)\" style=\"top:228px;left:326px;width:108px;height:93px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(52)\" style=\"top: 566px; left: 50px; width: 405px; height: 109px;\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(76)\" style=\"top:702px;left:50px;width:98px;height:151px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(80)\" style=\"top:702px;left:164px;width:98px;height:151px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(82)\" style=\"top:702px;left:279px;width:128px;height:151px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(84)\" style=\"top:702px;left:419px;width:98px;height:151px\"></div>\n\n\n        <div class=\"addContentLinkThree\" style=\"top:619px;left:530px;height:10px;width:104px;\">\n          <a href=\"https://www.olympics.com/ioc\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLinkThree\" style=\"top:627px;left:530px;height:10px;width:110px;\">\n          <a href=\"mailto:olympicreview@olympic.org\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": "Olympic Review  5  Issue 120  executIve board President Thomas Bach Vice-Presidents Ser Miang Ng, John Coates AC, Nicole Hoevertsz, Juan Antonio Samaranch Members Robin E. Mitchell, Denis Oswald, Nenad Lalovic, Ivo Ferriani, HRH Prince Feisal Al Hussein, Nawal El Moutawakel, Mikaela Cojuangco Jaworski, Gerardo Werthein, Kristin Kloster, Emma Terho  40  olympIc vIllage  Paris 2024 marks a century since the first Olympic Village appeared at a Games.  olympIc revIew  42  through the lens  A pictorial look at Paris in 1924 and today.  Corporate Communications & Public Affairs Director Christian Klaue Editor-in-Chief Katharine Mann Deputy Editor & French Edition Lucile Tonnerre Spanish Edition Dolores Blázquez Production Agency Touchline Production Michael Stoneman, Glyn Wilmshurst, John Murray, Sam Price, Conor Ketley Design Liz Rankin, Shyama Rajani, Apostolis Tatasopoulos Image retouching Liz Rankin Translation Aurélien Sagnier, José-Luis Morais, Laura Solana Proofreading Fréderic Brunet ISSN: 0377-192X Printed in the UK  Images Cover image: Getty Images Inside: IOC; IOC/Greg Martin; IOC/Philippe Woods; IOC/Giulio Locatelli; IOC/Marcel Imsand; IOC/Christophe Moratal; IOC/ Nelson Chavez; IOC/Jason Evans; IOC/ Bob Long; IOC/United Archives; Kishimoto/ IOC; Getty Images; Paris 2024 Organising Committee for the Olympic and Paralympic Games; Henri Garat/Ville de Paris; Sophie Robichon/Ville de Paris; Philippe Millereau/ Ville de Paris; Emilie Chaix/Ville de Paris; ©Société de livraison des ouvrages olympiques – SOLIDEO/ILLUMINENS©/ Dominique Perrault/Ingérop/Une Fabrique de la Ville/VITEC/Agence TER/UrbanEco/JeanPaul Lamoureux; ©SOLIDEO – Dronepresse; Jean-Marie Hervio/KMSP; Little Shao/Red Bull Content Pool; Myriam Fox-Jerusalmi; CNOSF; BOA; Bill Morris  52 parIs 2024  contacts  76  opInIon  Sir Hugh Robertson and Bill Morris share their views on staging the Olympic Games and the positive impact on the host city.  80  82  84  Book reviews from the IOC Olympic Studies Centre.  Olympians and figures from the Olympic Movement who have passed away.  The groundbreaking Games of 1924 and 2024.  olympIc studIes  obItuarIes  the last word  Olympic Review uses PEFC-certified paper stock sourced from sustainably managed forests. Olympic Review is published by the International Olympic Committee. The articles published in Olympic Review do not necessarily reflect the opinions of the International Olympic Committee. No articles may be reproduced without the permission of the IOC Corporate Communications & Public Affairs Department.  All information correct at the time of going to press  Contributors from outside the Olympic Movement look ahead to the Games for a new era: Alain Lunzenfichter discusses what we can expect in Paris in a year’s time; Michel Cadot, Tony Estanguet and Pierre Rabadan give the inside view from the French capital; athletes past and present provide their perspectives on why the Games will be transformative; and coach Myriam Fox-Jerusalmi looks at the significance of gender parity among athletes.  Please send your letters to: Olympic Review, IOC Corporate Communications & Public Affairs Department, Maison Olympique, 1007 Lausanne, Switzerland website: www.olympics.com/ioc email: olympicreview@olympic.org tel: +41 (0)21 621 6111"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img id=\"6-title-1\" class=\"halfScale\" style=\"top:94px;left:42px\" src=\"/120/static/_content/6-title-1.png\"/>\n        <img id=\"6-quote-1\" class=\"halfScale\" style=\"top:595px;left:476px\" src=\"/120/static/_content/6-quote-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:611px;left:572px;height:16px;width:82px;\">\n          <a href=\"https://www.paris2024.org/en/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim.fromTo(idOf(\"6-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"6-quote-1\"), 0.4, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n          removeContentLinks();\n      }\n      ",
    "searchText": "6  Foreword  foreword by thomas bach  O  ne year from now, the city of Paris and France will welcome the world to the Olympic Games. Already now excitement is building for what promises to be a spectacular festival of sport in one of the world’s most iconic destinations. Coming 100 years after Paris last hosted the Olympic Games, Paris 2024 will be truly the Games of a new era. These will be the ﬁrst Games to fully beneﬁt from the Olympic Agenda 2020 reforms from start to ﬁnish. The ambition of the organisers is not simply to put the Olympic Games at the heart of the city, but to put the city at the heart of the Olympic Games. This is reﬂected in the many innovations that are being introduced. In a departure from previous Games, the Opening Ceremony is being taken out of the stadium with the athletes’ parade  1 Paris 2024 is introducing many innovations to ensure the city and its people are at the heart of the Games.  planned on a series of barges down the river Seine. The plan is for some half a million people to line the banks of the river and cheer as the athletes slowly ﬂoat through the city. Meanwhile, much of the sporting action will unfold against a backdrop of famous Parisian landmarks. In the interests of sustainability, 95 per cent of venues are either existing or temporary. The equestrian events will take place in the gardens of the Château de Versailles, while the beach volleyball will be held at the Champ-deMars. The triathlon and the open-water races will start in the river Seine at the Pont Alexandre III not far from the Eiffel Tower. Some of Paris’s most emblematic sites are also being transformed into competition venues. The Grand Palais will host the taekwondo and fencing competitions, while the Esplanade des Invalides will be the site of the archery. Visitors to the Games will be able to take in the sights and sounds of Paris as they move between venues on foot or by public transport, and so combine a visit to the Games with sightseeing in Paris. The organisers are also keen for the population to get involved in the sporting activity. So, a Mass Participation Marathon will allow members of the public to pit themselves against the world’s best athletes by running the course of the Olympic Marathon, itself a symbolic route between Paris and Versailles tied closely to France’s history. The plan is for the same number of women as men to participate who will then be able to say that they “took part in the Olympic Games”. In another landmark, Paris 2024 will be the ﬁrst completely gender-equal Games in history with exactly the same number of women as men competing (5,250) in the same number of events,  1  “In addition to being gender equal, Paris 2024 will also be more youthful with four youth-focused sports on the programme” a far cry from 1924 when women accounted for only about four per cent of competitors. This is a hugely important milestone. But full gender equality is not the only innovation. In addition to being gender equal, Paris 2024 will also be more youthful with four youth-focused sports on the programme: breaking, skateboarding, sport climbing, and surﬁng. In keeping with the Paris organisers’ ambition to involve the"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.png",
    "zoom": null,
    "content": "\n        <div id=\"7-sig\" class=\"abs noOverflow\" style=\"top: 781px; left: 478px;    height: 43px; width: 142px;background:white\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax()\n          pg7Anim\n            .fromTo(idOf(\"7-sig\"), 0.6, {width:142,x:0}, {width: 0,x:142, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop()\n          removeContentLinks();\n        }\n      ",
    "searchText": "whole of France in the Olympic Games, including the overseas territories, the surﬁng competition will take place in Tahiti. In the pages that follow, you will be able to read what athletes and visitors to Paris in 2024 can hope to experience. Thanks to the testimonies of athletes and personalities from the Organising Committee and France, it will be possible to catch a glimpse of what to expect in Paris in 2024. We also trace the development of women’s sport in France and at the Olympic Games, and the groundwork that has led to the full gender parity that we will witness next year. Paris 2024’s legacy plans too are well in hand thanks to initiatives like “Terre de Jeux”, which are encouraging daily practice of sport among  schoolchildren and young people throughout the country. Yet, it is not possible to talk about Paris 2024, without a nod to the past and notably the Olympic Games Paris 1924. Because while those Games took place almost 100 years ago, they too were innovative in their day and their legacy laid the foundations of much of what we are able to see at the Games today. So, to pay homage to the Games of 1924, there is an account of those Games and of how they changed Paris, France, and the Olympic Games. The Olympic Games Paris 1924 were also the swansong of Pierre de Coubertin, the renovator of the modern Olympic Games, so Olympic Review pays tribute to him too. Paris 1924 was the Games of  many ﬁrsts, including the ﬁrst Olympic Village and the ﬁrst formalised Opening and Closing Ceremonies, and gave us some of the ﬁrst global sports superstars. All these are touched upon in historical pieces devoted to Paris 1924. As excitement builds for the Games of the XXXIII Olympiad, it simply remains for me to say “Rendez-vous in Paris” in 2024. ■  Thomas Bach, IOC President"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 8-title\" style=\"top:591px;left:40px\" src=\"/120/static/_content/8-title-1.png\"/>\n        <img class=\"halfScale 8-sub\" style=\"top:804px;left:43px\" src=\"/120/static/_content/8-sub-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:801px;left:59px;width:114px;height:13px;\"><a href=\"https://olympics.com/ioc/news/ioc-president-pays-tribute-to-honour-member-henry-kissinger-as-he-celebrates-his-100th-birthday \" target=\"_blank\"></a></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.fromTo(cOf(\"8-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"8-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n          setTimeout(function(){\n            addContentLinks();\n          },1500)\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "a long-tIme frIend of the olympIc movement AS HENRY KISSINGER CELEBRATES HIS 100TH BIRTHDAY, OLYMPIC REVIEW PAYS TRIBUTE TO THE ROLE THAT THE IOC HONOUR MEMBER AND FORMER US SECRETARY OF STATE HAS PLAYED IN THE OLYMPIC MOVEMENT. BY ALAN ABRAHAMSON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "9  S  1  1 Henry Kissinger has been a trusted advisor to President Bach. 2 Kissinger and Bach at the Olympic Museum in 2019.  ome years ago, at New York’s famed 21 Club, the United States Olympic Committee (USOC) bestowed upon Henry Kissinger its Douglas MacArthur Award. When most people think of MacArthur, the image that comes to mind is of the general, who led the United Nations Command in the Korean War, jaunty in his cap, pipe and Ray-Ban sunglasses. A hidden bit of history is MacArthur’s role in the Olympic Games Amsterdam 1928. The President of the USOC had died the year before; MacArthur, it was suggested, should replace him, and why not? In important domestic circles, he was notorious for his advocacy of sports at West Point, the US Army military academy and, more broadly, amateur sports. MacArthur took the job. And with enthusiasm. Understand that when he did so, the future of the Olympics was hardly as we understand it, after all that has happened. Television was far off on the horizon. The modern Games were just over 30 years old. It was unclear how much time, effort and money the United States ought to pour into the Olympics. Los Angeles had been awarded the 1932 Games – yes, in 1923, but California was a very long way away from decision-makers and ﬁnanciers in New York and Washington, and 1927 was ﬁve very long years and Amsterdam a very big ocean away. The Games, you might say, were at something of an inﬂection point. The Douglas MacArthur Award – it’s now bestowed by what’s been renamed the United States Olympic and Paralympic Committee (USOPC) – is given to someone who has offered “exemplary service”, because what MacArthur did in 1928, as the bestselling author and historian Arthur Herman makes plain in his 2016 biography about the general, was nothing less than save the Olympics for the United States and, arguably, beyond. The American team that went to the Netherlands won 22 gold medals; it set 17 Olympic and seven world records. Fast forward to the turn of the millennium. The IOC, stung by a series of revelations involving Salt Lake City’s winning bid for the 2002 Olympic Winter Games, was launched on a wrenching reform process that ultimately saw it enact a 50-point reform programme. Six IOC Members were expelled; four resigned. Kissinger played what all  involved have called a key behind-the-scenes role in guiding the reforms. For his part in those reforms, the USOC gave him the MacArthur Award. The IOC would make him an Honour Member. You see the parallels. There’s no question the Olympic Movement was at yet another inﬂection point. That night, at the 21 Club, Kissinger said, and keep in mind this is a man who has done and seen it all in geopolitics, “Even an advanced degree in diplomacy doesn’t help you ﬁnd your way through all the complexities of the IOC.” On the occasion of Kissinger’s 100th birthday this spring, it’s time – well past time, perhaps – to acknowledge again and anew the key role he has played in the Olympic Movement. As ever, behind the scenes. He did so when the IOC faced its worst crisis, in 1999 and 2000. And he has been a trusted advisor during Thomas Bach’s presidency. As Bach has said, the two men met in the context of the IOC 2000 reforms. In all, the IOC President at the time, Juan Antonio Samaranch of Spain, brought together 82 personalities and dignitaries from around the world – corporate leaders, athletes, diplomats – and divvied them up into three working groups. Bach, a gold medal-winning fencer and an IOC Member by then for about 10 years, led the panel examining “the role of the IOC”. Kissinger was slotted into this group, too.  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "10  Feature: Henry Kissinger  1  Bach is, among other things, a student of history. He had read all of Kissinger’s lengthy memoirs. Too, he and Kissinger come from the same part of Germany – Franconia; Kissinger, of course, a Jewish refugee who ﬂed Nazi Germany with his family in 1938. As Bach has said, he – by then an accomplished lawyer and seasoned Olympic politician – was just a bit nervous about meeting Kissinger. Not to worry. Kissinger said a few words in German and the ice was broken. “Kissinger was the kind of leading guy among these personalities,” Bach said, and the reasons why were elemental. One, Kissinger’s “genius”, as Bach put it: “He can put every issue you raise with him into a global perspective without losing sight of the particular national context.” Moreover, his perspective lends itself not just to what might be happening now but “where it could lead to”. Two, in person Kissinger is down to earth and has a keen sense of humour. “He’s very sharp analytically but, you know, a very warm personality,” Bach said. It’s this duality that others who have come to know Kissinger not only remark upon but similarly ﬁnd remarkable. “He is absolutely brilliant and concise and can grasp the relevance of any event  that’s going on and articulate it in three or four sentences,” said Bill Hybl, a former IOC Member and two-time USOC President who also served on the IOC 2000 Commission. Hybl also said, with an admiring laugh, “In his home he used to have, and may still have, I don’t know, numerous televisions so he could watch most of the NFL games at the same time. He just loves sport.” Mitt Romney is now a United States senator from Utah. He was the 2012 Republican nominee for US President after serving as Governor of Massachusetts from 2003 to 2007. In the midst of the IOC’s worst crisis, he was brought in to lead the Salt Lake City 2002 Organising Committee. “In a world that looks to fast-talking, native-born, coiffed-hair showmen, ‘Dr K’ surpassed them all, thanks to his integrity, insightfulness, patriotism and genius,” Romney said, adding, “We won’t see the likes of him again.” Dick Pound, the Canadian lawyer and recent IOC doyen, tells the story of a 30-something meeting the then-75-year-old  1 Kissinger chaired the IOC 2000 Commission after the crisis around Salt Lake City's winning bid for 2002.  Kissinger and Kissinger saying, because he obviously had such a plan, “Well, what’s your 25-year-plan?” Kissinger, in a lengthy interview published in The Economist magazine shortly before his 27 May birthday, was asked to identify “characteristics of leadership”. His reply: “Identify where you are, pitilessly ... deﬁne objectives that can enlist people, ﬁnd means, describable means, of achieving these objectives. Link all of these to your domestic objectives, whatever they are.” Kissinger famously wrote in 2019 about the Olympics: “Of course, the Games alone will not prevent wars or end conﬂicts. But the Olympics may be taken as inspiration in an international search for understanding through and alongside contestation.” When Bach was elected IOC President in 2013, he reached out to Kissinger and looked to re-establish contact. Over the years, when Bach has travelled to New York, the two have met. They also have conferred otherwise. The years have, meanwhile, offered any number of issues the two men might have conferred about: Russia, China, North Korea, a certain controversial United States President, the effects of a global pandemic on the Games. No one will say. Kissinger’s role is – behind the scenes. Just one time, once, the genuine warmth between the two was made plain. In 2019, when the IOC’s new Olympic House on the shores of Lake Geneva was about to be dedicated, the Swiss President was – formally – the ﬁrst official visitor. Informally, Henry Kissinger had been there just before, the ﬁrst visitor to Bach’s new office. A picture documents the scene. That’s for the record. This, too – this bit of advice Kissinger has shared: “He told me once, he gave me an example, he said, never try to make a decision because you think you will get a positive headline,” Bach said. “The perspective … you cannot take getting a positive headline today and the decision would be a disaster in four or ﬁve years or in one year, and that’s again the perspective he has and this is again what he also sees for the IOC, that we cannot change decisions for the day. “We have to consider the long-term effects and that we have to try to consider it from the end.” ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "WORLDWIDE PARTNER"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 12-title\" style=\"top:158px;left:42px\" src=\"/120/static/_content/12-title-1.png\">\n        <img class=\"halfScale 12-sub\" style=\"top:257px;left:43px\" src=\"/120/static/_content/12-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.fromTo(cOf(\"12-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"12-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "12  Beyond the rings  beyond the rIngs  Sport and peace We should always strive for all athletes to be able to participate in competitions, rather than using sport to deepen rifts, says Karl-Friedrich Wessel  1  W  hen a rallying call goes out to get active for peace, if it is directed at sports organisations and churches, and not just in relation to the war between Russia and Ukraine, then it is necessary to take part, even if it takes place in a different form – by putting pen to paper.  It makes a lot of sense to place the focus on sport, and this is particularly challenging for both athletes and sports scientists. Because hardly any other social system is as good at attracting publicity as sport. For anyone who belongs to this system, the responsibility is correspondingly great. Sport, by which I mean the entire multi-branched system, depends on peace,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  13  Issue 120  and is therefore particularly threatened by war. This matters greatly, as sport is existentially important for the existence of society, for the development of all individuals throughout their ontogenesis, from conception through to death. Sport is a basic human need, even if not everyone realises it; it is an anthropological need. Precisely in an age of increasing physical inactivity for many people, it contains the quality needed for life. One can of course live without sport, and simply watch athletes, with no physical or mental involvement of one’s own. However, the concept of sport is then completely deprived of its substance. In many cases it then exists only when seen on a screen or read about in the pages of a newspaper. No one can object to that, because no one can do anything about it. Moreover, it merely strengthens the connection between sport and peace, as anyone who seeks to derive pleasure from sport in this way should be just as interested in peace as someone who actively advocates peace for anthropological reasons. In saying this, I am denying in no way the fact that visible, exemplary behaviour in sport can be an important stimulus if athletes and sports officials truly behave in a manner concomitant with their responsibility. For what is at stake is not defending or repeating a particular political opinion, but rather the completely independent position that corresponds to the essence of sport. Sport is the result of a long cultural development, which is bound up with world history just as with the individual development of identities, even when there is no personal participation in sport. The age-old competition between individuals is reflected in sport. It is difficult for an individual to engage in self-comparison: at best, they can do so with regard to their own development; but they also need another person for the comparison. The tussling of small children is a form of comparison, and not just a physical one. Physical education very quickly qualifies this comparison and  1 The Olympic Games bring athletes from all over the world together.  teaches how to use rules to make the comparison. Anyone who takes sport seriously knows that sport needs rules, which are not always easy to follow. However, this is precisely what makes them rules. Moreover, there are sets of rules at all levels, from individual to team sports. They have developed in order to prevent injuries of whatever nature, including in a moral sense. As such, sport is the opposite of war. It is about one versus another, and thus winners and losers, but without injury, let alone death. The loser congratulates the winner, often in the hope of being the winner of their next encounter, or with the realisation of remaining the loser, of being weaker. War, on the other hand, is the prevention of such comparisons, and is therefore destruction. Even if many wage war or think of doing so in order to preserve culture, it is still destruction. Wars are waged for other reasons entirely: not for a cultural comparison, but to destroy the other. We are well aware today that wars are fought for political and economic reasons; and we also know that it is not easy to identify clear reasons for wars. As a result, sport has or should be given a braking function, and maintain and attempt to qualify this. Sport has the function of maintaining peace, and for this reason many different interests should be subordinated to this. Athletes need to show up, not just to preserve peace, but also to preserve their own profession. War ends sport; not for everyone immediately – but sooner or later for everyone, too. Excluding athletes from international competitions or similar events is nothing more than the waging of war by other means, and so is not an option for peace. The participation of all athletes should always be the principle, which means that ending war is more important than excluding athletes from competitions. A utopian vision, but a wonderful one that points the way forward. It sounds very logical when athletes from countries that are supposedly or actually involved in an unjustified war are suspended from international competitions. But in reality, it is a violation of the duty of the International Federations, whose  job is to ensure that all of the world’s athletes can take part. If necessary, officials could be disinvited, but again with a sense of proportion. In this instance too, the cultural policy function, or rather the anthropological function, of sport should be used. Perhaps it would be an idea if the whole sports world could agree not to hold any international championships while any war is being fought – as a weapon against all wars[!] Anyone seeking sporting comparison should be able to resist all warlike temptations and, when these arise, try to put an end to them. Calling on the sports world to do this is the dictate of the moment. But those who use sport to deepen rifts, for example by excluding athletes from international competitions, are acting contrary to reason. ■  Karl-Friedrich Wessel earned his doctorate in 1968 with a study on critical realism and qualiﬁed as a professor in 1975 with a work on philosophy and pedagogy. In 1977, he was appointed to the Chair for Philosophical Problems of Natural Sciences at Humboldt University in Berlin, Germany, and from 1990 to 2000 he was the founder and then head of the Interdisciplinary Institute for the Philosophy of Science and Human Ontogenesis. He is currently leading a human ontogenesis project at Humboldt University and is Chair of the Society for Human Ontogenesis."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 14-title\" style=\"top:213px;left:50px\" src=\"/120/static/_content/14-title-1.png\"/>\n        <img class=\"halfScale 14-sub\" style=\"top:377px;left:68px\" src=\"/120/static/_content/14-sub-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:209px;left:44px;width:572px;height:121px;\"><a href=\"https://olympics.com/en/olympic-games/paris-1924 \" target=\"_blank\"></a></div>\n\n        <a href=\"https://www.youtube.com/watch?v=IIhV47I5pC0\" target=\"_blank\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:52px;top:503px\" src=\"/120/static/_content/white-play.png\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.fromTo(cOf(\"14-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"14-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n          setTimeout(function(){\n            addContentLinks();\n          },1700)\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "parIs 1924 a legacy of parIs 1900 or a prelude to parIs 2024?"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THIERRY TERRET, FORMER MINISTER DELEGATE FOR THE OLYMPIC AND PARALYMPIC GAMES PARIS 2024, REWINDS THE CLOCK 100 YEARS AND LOOKS AT HOW PARIS 1924 MARKED A TURNING POINT IN THE HISTORY OF THE OLYMPIC GAMES AND LAID THE FOUNDATIONS FOR SOME TRADITIONS THAT CONTINUE TO THIS DAY  Helen Wills (left) was one of the stars of Paris 1924, winning two tennis gold medals."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <img \n          class=\"abs halfScaleC halfpulse animatedpulse pointer\" \n          style=\"top:479px; left:122px;\"\n          onclick=\"pg16_gallery(0)\" \n          src=\"/120/static/_content/white-camera.png\"\n        />\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1  O  n 5 September 1924, Pierre de Coubertin published a long appraisal of the Paris Games, which had ended a few weeks earlier, in the Revue de Genève. “[We witnessed an] immense amount of technical effort,” he wrote, “from a group of skilled, selﬂess sportspeople in Paris – an effort persistently hindered by two groups of individuals given to interference in all areas at the present time, bureaucrats and politicians; a simultaneous effort from all the world’s athletes to overcome the economic difficulties and compete in the Paris Games in spite of everything; and ﬁnally a general lack of understanding, with numerous details misinterpreted, from the great failing pillar of modern civilisation, the press… This, in essence, summarises  the impressions left by the celebration of the Games of the VIII Olympiad.” The nostalgic tone of the text might seem to suggest that, three decades earlier, tensions had been non-existent, and that the ﬁrst modern Games had successfully stayed clear of non-sporting considerations. This is clearly not true, but the legacy of the earlier Games was perhaps not quite what one might expect. At the Sorbonne Congress, held from 16 to 23 June 1894, delegates adopted Coubertin’s proposal to revive the Olympic Games, agreed on the general principles and the programme, and decided on the location of the ﬁrst two editions, respectively Athens in 1896 and Paris in 1900. That ﬁrst experience of the Paris Games was clearly very much in Coubertin’s mind when, almost  20 years later, he successfully made the case for the French capital’s candidature before the IOC Members at the Lausanne Session on 21 June 1921. He was hoping, no doubt, to avoid a repeat of the organisational frustrations of 1900, when he had had to abandon many of his expectations for the Games, faced with political authorities who knew virtually nothing about sport and, above all, the need to merge the Olympic programme into that of the World’s Fair, to the extent that it was difficult to know which were actually Olympic events. The Games, with around 1,000 participants from 24 nations *, were held alongside a range of competitions and demonstration events – staged by the World’s Fair organisers – that were attended by nearly 58,000 participants from 30 nations. Coubertin also had to"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  17  Issue 120  The construction of the first-ever Olympic Village was another defining feature of the 1924 Games  accept that some events would be open to professional athletes and to women. The 1900 Games, spread out over more than ﬁve months and taking place across the Paris region, were lost amid the World’s Fair and received minor coverage in the press. Ultimately, they brought little beneﬁt to the French capital, which did not seek to make optimum use of the event, let alone build any kind of legacy from it, with the exception of the Vélodrome de Vincennes. In 1924, then, the lessons to be learned from 1900 were more about how to do things differently than continue with more of the same. With memories of the trenches of the Great War still painfully fresh, Paris wanted to showcase its ambitions on the world stage for reasons that were altogether different from those of the Belle Époque. While the political authorities back then had considered the Games a private initiative of no real interest, it was now the prospect of winning medals that justiﬁed the French Government’s determination to host the 1924 edition. It was in this context that the Games ﬁnally took place between 4 May and 27 July 1924. The Opening Ceremony – which had not existed in 1900 – was attended by senior government ﬁgures, whereas 24 years earlier the role of state officials had been limited to enhancing the prestige of the World’s Fair. The extended timeframe was not the only notable feature of the Games of the VIII Olympiad. While history remembers that they were held in Paris, in reality almost 20 venues hosted events, of which only three were in the French capital (the Vélodrome d'Hiver, the Stade Bergeyre and the Piscine des Tourelles), with around a dozen in the  1 The Paris 1900 Games were spread over more than ﬁve months. 2 Around 1,000 athletes, from 24 nations, competed in the 1900 Games.  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "18  Feature: Paris 1924  outer suburbs (Colombes, Argenteuil, Versailles, Meudon, Saint-Cloud, Bagatelle, Auteuil, Billancourt, Issy-les-Moulineaux, Clichy and Vincennes), and several more some distance from Paris: Meulan, Le Havre, Châlons-sur-Marne and Reims. A choice that was ultimately not too dissimilar to the one made in 1900. Some 3,089 athletes – including 135 women – from 45 nations competed in more than 120 events in around 20 sports †. For the venues, particularly those designed to provide a tangible legacy, the organisers mostly opted to adapt existing facilities, dropping the idea of building a stadium in the heart of Paris. In the northwestern suburb of Colombes, a private stadium, leased by Racing Club de France at the time, was expanded so that it could host the most prestigious events and the ceremonies, following political trade-offs in which arguments over the use of space – between the 1924 Olympics and the World’s Fair, due to be held a year later – were reminiscent of the discussions in 1900. The decision to build the Piscine des Tourelles, the only venue in the city of Paris itself that has been inherited from the 1924 edition for 2024, was taken less than a year before the Games opened. This aquatics stadium, presented as one of the most prestigious in the world, naturally banished memories  1  2  of the 1900 swimming events on the Seine, despite the technical issues that would have a long-term impact on the city’s budget. The construction of the ﬁrst-ever Olympic Village was another deﬁning feature of the 1924 Games. The Village, composed of small wooden cabins, was erected specially for the Games and dismantled after the event. Although there were no entertainment amenities, the temporary Village did offer a range of services – a hairdresser, newspaper kiosk, post office, laundry and restaurant – that delegations will also ﬁnd at Paris 2024, 100 years on. For the Olympic Village, as with other decisions, the 1924 Games organisers wanted to put innovation front and centre, reﬂecting the image that the city of Paris had historically sought to project. There were a host of new features, from the stadium architecture in"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "19  “jury of honour” – although this did not last more than a few years. Social innovation, while relative, was nevertheless substantial, particularly regarding the presence of women. Although Paris 1924 was the last edition of the Games at which women were not able to compete in athletics events, their participation in tennis, fencing and swimming, and – albeit less prominently – in other events (sailing and artistic gymnastics) was signiﬁcant at a time when they were still being ﬁrmly rejected by the world of sport. Some innovations, though, were the result of concessions. At the Lausanne Congress, held from 2 to 7 June 1921 at the same time as the annual IOC Session, one of the matters the IOC discussed was its relations with the International Federations (IFs) and National Olympic Committees. Until that point, the dynamic had been a precarious one, shifting between Games and Sessions. Coubertin, who was particularly concerned about the risk of the 19 IFs exerting control over the Olympic Movement, managed to prevent the creation of a “Federation of International Federations”, but had to accept the establishment of a permanent office, on the initiative of the Union Cycliste Internationale. Tensions between the two authorities were particularly evident in two key areas, which the Paris organisers would have to contend with for 1924.  Colombes to the use of telephones and electricity. The innovations extended to protocol elements with the introduction of both the Opening and Closing Ceremonies and the formalisation of the athletes’ oath ﬁrst taken in Antwerp four years earlier, as well as competition rules and techniques. The invention of lanes in swimming events, for example, can be attributed to the Paris Games. There were even some institutional developments, namely when Coubertin, fearing that nationalist tensions could tarnish the image of the Games, established a  1 Paris 1924 venue Piscine des Tourelles will be a training venue for athletes at the 2024 Games. 2 The 1924 Games hosted the ﬁrst Olympic Village, with facilities including a post office and laundry. 3 Women competed in fencing for the ﬁrst time in Olympic history in 1924.  3"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n      <a href=\"https://www.youtube.com/watch?v=D6RK0M6-GUg \" target=\"_blank\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:394px;top:443px\" src=\"/120/static/_content/white-play.png\"/>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "20  Feature: Paris 1924  Paris will be harking back to its Olympic past by organising geographically dispersed Games  1  The ﬁrst issue related to amateurism, at a time when the growing professionalisation of sport, particularly football, was becoming incompatible with the 19th century values to which the IOC Members continued to cling. Ultimately, it was decided that the question of amateur status for the Games would be determined by each IF, as would the official rules of competition, for the ﬁrst time. The second concerned the Olympic programme, which the IOC wanted to cut down – at the expense of cycling, football, tennis, sailing and shooting – while the IFs were calling for its expansion. In the end, only hockey, golf and archery were removed from the programme, although substantial changes were made to several events: equestrian vaulting and the 25.4kg shot put were scrapped, the women’s 300m breaststroke was replaced with a 400m event, and the number of categories was increased from ﬁve to six in Greco-Roman  wrestling, ﬁve to seven in freestyle wrestling, six to eight in boxing, etc. The Olympic programme in Paris was certainly original. Firstly, because various demonstration sports were added: basketball, volleyball, baseball, cage ball, artistic gymnastics, Basque pelota, Canadian canoeing, French boxing, canne de combat and other scout games‡ – some of which would have bright futures. But above all because the 1924 Games, amid the IOC’s demands and the organisers’ requests, could not fully decide whether to bear the hallmarks of the pre-war sporting world or those of the modern era. Rugby and football would embark, respectively, on their ﬁnal and penultimate Olympic adventures (in their then format):  1 Swiss gymnast Jean Gutweniger on his way to a silver medal in the pommel horse.  British resistance to the former, and the emerging siren song of the World Cup for the latter, against the backdrop of debates over amateur sport, would ultimately win out over the organisers’ ambitions. The Olympic cycling events in Paris met with success despite competition from the Tour de France, while the gymnastics tournament should be seen as the ﬁnal episode in the conﬂict between the proponents of educational and sporting gymnastics. The fencing competition, meanwhile, did not just pit champion against champion: the Italian and French fencers in particular embodied the conﬂicting traditions, dating back three centuries, of their two nations’ respective schools of fencing. All the traditional values of strength and virility were in evidence in the wrestling and weightlifting tournaments which, it has to be said, drew virtually no crowds even then. Boxing, having disappeared from the Olympic programme, returned in Antwerp and was back in Paris thanks to its historical signiﬁcance, but the amateur version on show was a far cry from the professional bouts on the other side of the Atlantic, which had captured the imagination of the boxing world and American society at large. By the same token, could lawn tennis really compete, in Paris, against the Davis Cup? Evidently not, as this was the sport’s last appearance on the Olympic programme until 1988. The Olympic status of polo – a sport that was dear to Coubertin – was in its twilight, reﬂected in a tournament for the elite players from a smal14-l number of countries. For the third time in history, after Stockholm 1912 and Antwerp 1920, the Games included painting, architecture, sculpture, literature and music competitions. It was a programme choice that made sense for Paris, given its artistic vibrancy, its sartorial eccentricities, which spoke to both the aspirations of the women’s"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Team Visa. Supporting athletes     more than 20 years.  Visa is a proud sponsor of the Olympic and Paralympic Games.  PV Sindhu India, Badminton Team Visa"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.png",
    "zoom": null,
    "content": "\n        <div class=\"addContentLinkThree\" style=\"top:635px;left:571px;height:11px;width:89px;\">\n          <a href=\"https://www.youtube.com/watch?v=B0wi4Qe3Iu8\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLinkThree\" style=\"top:649px;left:476px;height:11px;width:27px;\">\n          <a href=\"https://www.youtube.com/watch?v=B0wi4Qe3Iu8\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": "1  emancipation movement and new developments in fashion, and its high-society gatherings and music and entertainment hotspots. At the time, Paris was the spiritual home of the likes of Jean Cocteau, Colette, Paul Morant and Jean Giraudoux. The Dada movement was still in existence, and some of the major proponents of surrealism, from André Breton and Robert Desnos to Louis Aragon and Paul Éluard, were already prominent ﬁgures in the city. While the 1924 Olympic Games may have captured the world’s imagination, the “City of Light” owed its aura more to its ﬂourishing cultural scene. Incidentally, the quality of entries in the Olympic architecture and music competitions was not considered high enough to justify naming a winner. Unlike for the 1900 Games, the 1924 Games organisers took care to promote the event. For the ﬁrst time, the Olympics were partially broadcast live on the radio, with journalist Edmond Dehorter commentating on the competitions from a hot-air balloon. Some 724 journalists were accredited by the French Olympic Committee, which distributed thousands of brochures and sought to actively promote the event, for example by issuing three million stamps and 20,000 copies of two Games posters  designed by Orsi and Jean Droit. In 1900, there had been no real desire to promote the Olympics to a wider audience, or ahead of the event; this changed in 1924, heralding the growing media coverage of the Games, which Paris 2024 has taken even further. It is far from clear whether this promotional campaign had any impact. Granted, in his appraisal, the Secretary General of the Paris Organising Committee, Frantz Reichel, considered the Games to have been a real success, drawing about half a million spectators across all the events. In reality, if the two most popular sports, football and athletics, are taken out of the equation, the number of paying spectators barely reached 175,000 – a relatively modest ﬁgure taking into account the number of events organised and the ﬁve million tickets printed. This appraisal is also to be measured against the 1900 Games, for which we still do not know the exact number of spectators who attended the Olympic events, among the 50 million or so visitors to the World’s Fair. On a sporting level, the American athletes arrived meaning business, and they went on to win 45 gold medals – far more than Finland (14), France (14) and Great Britain (9). With the exception of Germany, which had not been invited, the ranking by and large conﬁrmed  the sporting hierarchy of the time. This stability is illustrated through a comparison with the 1900 Games, when France had come top of the ranking ahead of the USA and Great 1 Britain. But in 1900, international sport did not yet have any real champions, whereas in 1924, heroes were born, or conﬁrmed their stature. History will forever remember the names of ﬁve-time champion Paavo Nurmi, the most prominent of the “Flying Finns”; British sprinter Harold Abrahams, immortalised in 1981’s Chariots of Fire; the USA’s Johnny Weissmuller, Hollywood’s future Tarzan; France’s Charles Rigoulot, “the strongest man in the world”; the Uruguayan football team; Yugoslavian gymnastics prodigy Leon Štukelj; American tennis player Helen Wills; and many more besides. The 1924 Games reshaped the structural and political foundations of the Olympic Movement (Executive Board, Charter, etc.), consolidated most, though not all, of the major protocol elements, and saw the event itself reach a level of organisation and legitimacy that was a world away from the ﬁrst editions. Nevertheless, it was clearly the Prague Congress, held from 26 May to 4 June 1925, which had a transformative impact on the way the IOC functioned and the organisation of future Games. Henri de"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  23  Issue 120  Baillet-Latour taking over as President from Coubertin, the new inﬂuence of the Executive Board, the new dynamic between the IOC and the IFs, the deﬁnition of amateur status, the return of Germany, the expansion of the women’s programme and the recognition of the Olympic Winter Games – all were conﬁrmed or addressed after Paris, providing a somewhat different framework to subsequent Olympiads. The 1924 Games, then, signalled a transition rather than a revolution. To a certain extent, Paris marked the end of “Coubertin’s Games”. A new stage had begun – one in which the Olympics would have to respond to two major challenges, professionalism and nationalism, in a competitive sporting landscape, reﬂected in the emergence of parallel events such as the “Workers’ Olympics” in 1925, the “Women’s World Games”, established by Alice Milliat in 1922 (see p. 31), and the Games for the deaf held in Paris in August 1924. These events were, respectively, set up in response to the perceived complicity with bourgeois capitalism, unfair domination of male athletes and insufficient acknowledgement of more vulnerable groups: all of which are areas that Paris 2024 is explicitly seeking to address today, with gender-equal, inclusive Games that appeal to the whole population. In the same way that Paris 1924 was, in part, an attempt to break from the precedent of Paris 1900, Paris 2024 is looking more broadly to limit the association with the experience of life in the French capital 100 years earlier, by giving prominence to 21st century issues such as the transition to a greener society, the ambition for a tangible and intangible legacy, and security concerns. Nevertheless, there are more parallels than ﬁrst appear: the desire to use existing sports facilities in a context of urban saturation, and even re-use, for some events, the Colombes stadium and the Piscine des Tourelles, which have since been renamed; the constant push for innovation; the importance of communication, even though radio is now less relevant than television  1 The Colombes stadium will host hockey 100 years on, renamed as the Yves-du-Manoir Stadium. 2 Paris 2024 wants to highlight 21st century issues like the transition to a greener society and legacy.  and social media; difficult decisions about the Games programme; and the ambition to connect sport with culture. What’s more, although the 2024 edition will be concentrated over two weeks, Paris will be harking back to its Olympic past by organising geographically dispersed Games, whose reach will extend all the way to the waves of Teahupo’o in French Polynesia. And all this in a geopolitical context of war and economic crisis, a century after Games marked by the consequences of the Great War. ■ Thierry Terret was a professor of sports history at the University of Lyon, France, before embarking on a career as a senior civil servant, ﬁrst as a rector in several regions of France and then as ministerial delegate for the 2024 Olympic and Paralympic Games. A former president of the International Society for the History of Physical Education and Sport (ISHPES) and of the French Society for the History of Sport, he has written or edited some 35 books and 350 articles and chapters on the history of sport, with a particular focus on gender, politics and cultural transfer.  2  End notes * On this topic, Olympic historians cite figures ranging from 28 to 30 nations. † These figures are subject to debate. The Games Official Report actually lists 19 “sports and games”, plus the art competitions and winter sports. The events are numbered from 1 (athletics 100m) to 126 (the 8m sailing race); the numbering then stops for the art competitions before picking up again for the winter sports (from 127 to 142), even though these were not officially part of the Olympic programme. ‡ Several of these activities were combined in an event featuring children’s sport and games, dubbed “Les Jeux de l’enfance” in the official programme of the Olympic Games or “Games for All” by the media. See: T. Terret, “Jeux de l’enfance et démonstrations”, in T. Terret (dir.), Les paris des Jeux olympiques de 1924, volume 4 : Les paris culturels, Biarritz, Atlantica, 2008, pp. 1145-1170."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 24-title-1\" style=\"top:138px;left:44px\" src=\"/120/static/_content/24-title-1.png\"/>\n        <img class=\"halfScale 24-title-2\" style=\"top:170px;left:43px\" src=\"/120/static/_content/24-title-2.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:534px;left:61px;height:13px;width:151px;\">\n          <a href=\" https://olympics.com/ioc/pierre-de-coubertin\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.fromTo(cOf(\"24-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"24-title-2\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n          setTimeout(function(){\n            addContentLinks();\n          },1700)\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "parIs 1924 and pIerre de coubertInís  endurIng love for france THE GAMES OF THE VIII OLYMPIAD EMBODIED PIERRE DE COUBERTIN’S VISION FOR THE WORLD’S GREATEST SPORTING SPECTACLE, WITH MANY OF HIS IDEAS REMAINING RELEVANT TODAY. BY GEORGE HIRTHLER  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  25  Issue 120  T  he Olympic Games Paris 1924 were Pierre de Coubertin’s swansong. As a master of theatrical impact, he had prepared the stage for his exit years before. When he had announced his retirement in 1921 – in a poignant letter sent to his IOC colleagues – he asked them to grant him one last wish “… in favour of (my) native city, Paris …” and award the 1924 Olympics to his birthplace while naming Amsterdam host of the 1928 Games. He knew the IOC would not deny him the privilege of celebrating the culmination of his historic Olympic work in the capital of the country for which he ﬁrst proclaimed his “wild passion” at the age of 12. As much as he loved the Olympic Movement, which he had launched at the Sorbonne 30 years before, Coubertin loved France even more. He wrote continuously of its history, sought to promote its stature  1 Pierre de Coubertin was keen for his last Games as IOC President to be held in Paris. 2 Coubertin (middle) hands out awards at the Paris 1924 Closing Ceremony.  2  internationally, embedded its language and values at the heart of the Olympic Movement, and admired above all the success of the Third Republic, to which he had rallied in his twenties to lend his considerable intellect and talents to the challenges of French education reform in the 1880s. In fact, his original motivation for resurrecting the modern Olympic Games was anchored in his hopes that the event itself might deliver glory to his home country. In 1909, reﬂecting on Germany’s excavation of ancient Olympia from 1874 to 1880 during his teenage years, he wrote: “Nothing in ancient history had given me more food for thought than Olympia. This dream city ... loomed with its colonnades and porticos unceasingly before my adolescent mind. Germany had brought to light what remained of Olympia; why should France not succeed in rebuilding it splendours?” As if to punctuate his love for France later in life, at the age of 52 in 1915, after moving the headquarters of the IOC from Paris to the safe shores of neutral Lausanne, Switzerland, he set aside his presidential Olympic duties to put on the uniform of the French army in defence of his nation in World War I. Too old to report to the front lines, he worked for the  Ministry of War in the Propaganda Department, travelling around the French provinces giving lectures to stimulate the nation’s esprit de corps. Although he had launched a movement to foster peace among nations, when it came to France, Coubertin could not be a paciﬁst. Returning to Paris in June of 1924 to put the crowning touch on his Olympic career, his heart brimmed with emotion and his mind was crowded with thoughts of what he had achieved and what he was about to leave behind. With the pride of a patriot, he believed that Paris – the indisputable cultural capital of the world – would put the ﬁnal seal of immortality on his life’s work and ensure that his global movement for friendship and peace through sport would have a permanent place on the international calendar. Having once again resurrected the Games after the devastation of World War I, in Antwerp in 1920, a Games which by necessity had a military bearing, he was counting on Paris to lift the celebration to heights of athleticism and culture that would exceed by far the previous six Olympiads and ﬁnally fulﬁl his extraordinary vision. All the signs suggested he would not be disappointed. The Opening Ceremony"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "26  Feature: Pierre de Coubertin  was scheduled for 5 July, and teams from 45 nations were already settling into the new Olympic Village – a French innovation that symbolised the worldwide unity the Games sought to foster. A record number of 3,089 athletes, including 135 women, were set to compete. But before the feats of athleticism began, the 30th anniversary of the founding of the modern Olympic Games had to be properly enshrined in their birthplace. Amid a large crowd in the Court of Honour at the Sorbonne, Coubertin and his IOC colleagues welcomed the 13th and ﬁrst Protestant President of the Third Republic, Gaston Doumergue, who had only been in office for 10 days. Out of gratitude for the host city and country, Coubertin presented Doumergue with a small case containing two gold medals, the ﬁrst inscribed 30 years earlier as “The International Congress in Paris proclaims the revival of the Olympic Games, 23 June 1894”. The second commemorated the moment: “The nations assembled here to celebrate the 30th anniversary of the revival of Olympism, 23 June 1924.” That night, President Doumergue hosted a banquet at the Élysée Palace for Coubertin and the IOC, offering toasts and official admiration for the Olympic Movement. A few days later, at another reception hosted at the Hôtel de Ville by the president of the city council and the prefect of the Seine, Coubertin let his gratitude ﬂow, thanking Paris for lifting the Olympic Games toward new heights while reminding his hosts that whatever happened in the days ahead, his great global work would continue: “… the ocean of sport seems to have its ups and downs just like the salt ocean,” he said, but “… sport has become international and we may therefore hope that this movement will not stop, since if it were to weaken at one point it would revive at another.” And then he closed his speech with a loud proclamation, “Long live Paris!” Once the Games began, the quality of the competition sparkled with excellence. Johnny Weissmuller, the American swimmer who would go on to Hollywood fame as Tarzan, set an Olympic record in the 100-metre swim, beating the previously unbeatable Duke Kahanamoku from Hawaii, who had won gold back-to-back in the previous two Olympics. The Paris Games showcased the running  1  brilliance of Paavo Nurmi, who would go on to win nine gold medals in his Olympic career, and the Chariots of Fire heroes Eric Liddell and Harold Abrahams. Despite his stated opposition to women competing in the Games, Baron de Coubertin never blocked their participation and the number of women competing grew sixfold under his presidency – and Paris served as the new pinnacle of that growth. As if to celebrate, the baron took his nephew, Christian de Navacelle, and his niece, Marie-Marcelle de Coubertin, to the women’s tennis tournament, where the 18-year-old American sensation, Helen Wills, who would ultimately win eight Wimbledon titles and become America’s ﬁrst female global sports celebrity, beat the French champion, Julie Vlasto, for the gold. While Coubertin had many battles behind the scenes with French sports officials in the lead-up to the Games, there is no doubt Paris 1924 delivered for le Rénovateur, marking the end of his era in the city of his birth by producing the ﬁnest Olympic festival yet staged. A year later, at the IOC Congress in Prague, Czechoslovakia, the baron would mount the podium in the town hall and challenge his colleagues to carry on his work as he stepped down.  In that farewell, Coubertin was full of gratitude, but o!ered his colleagues a series of warnings against the dangers ahead. Foremost among the principles he exhorted them to protect was universalism: “Is there any need to recall that the Games are not the property of any country or of any particular race, and that they cannot be monopolised by any group whatsoever? They are global. All people must be allowed in, without debate, just as all sports must be treated on equal footing, without concern for the ﬂuctuations or caprices of public opinion.” Even today, his message carries a moral immediacy that reﬂects the timeless qualities of his Olympic vision, which Paris and France were, and are, uniquely equipped to celebrate. ■ George Hirthler is an American writer. He is the author of the historical ﬁction, The Idealist, a novel about the life and times of Baron Pierre de Coubertin. He was awarded the Pierre de Coubertin Medal in 2022.  1 Coubertin encouraged his colleagues to continue his legacy at the 1925 IOC Congress in Prague."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "         "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 28-title-1\" style=\"top:39px;left:40px\" src=\"/120/static/_content/28-title-1.png\"/>\n        <img class=\"halfScale 28-sub-1\" style=\"top:365px;left:43px\" src=\"/120/static/_content/28-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim.fromTo(cOf(\"28-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"28-sub-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "women at the olympIc games a long journey (1896−2024)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.png",
    "zoom": null,
    "content": "\n      <div class=\"addContentLinkThree\" style=\"top:794px;left:307px;height:14px;width:99px;\">\n        <a href=\"https://olympics.com/en/news/paris-2024-first-games-to-achieve-full-gender-parity\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": "Women competed in swimming for the ﬁrst time at the Olympic Games Stockholm 1912.  THE OLYMPIC GAMES PARIS 2024 WILL MARK A MAJOR MILESTONE IN GENDER PARITY, WITH EQUAL NUMBERS OF MALE AND FEMALE ATHLETES, BUT THE ROAD TO GET HERE HAS BEEN LONG AND CHALLENGING. BY DR FLORENCE CARPENTIER"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1  I  t will have taken 130 years for the Olympic Games, the great four-yearly global festival of sport founded by Pierre de Coubertin in 1894, to offer equal opportunities to men and women in the stadium. Officially announced for the Games in Paris in 2024, the move towards gender parity between the 10,500 participants has been under way since the 1990s. Before then, the road to allowing women to compete in all the Olympic events was littered with resistance and sexist prejudices, but also militancy and courageous stands, in a century during which the roles assigned to men and women in society were progressively rethought.  The ﬁrst female Olympic champions: elegance, grace and beauty Like the conservative majority at the end of the 19th century, Coubertin was not in favour of sport for women, deeming it too violent for them, and morally indecent for a male audience. His plan for education through sport was aimed primarily at young men, the future elite leaders of nations. Like the allegory of Victory depicted on  the poster for the ﬁrst modern Games in Athens, women’s participation was limited to crowning the winners. And yet, already in 1896, women were enthusiastic about Olympic competition. The Greek press told the story of Stamáta Revíthi, a 30-year-old mother who was prohibited from taking part in the marathon. It was doubtless her pride that led her to run the distance the day after the official event. Against the founder’s wishes, the ﬁrst sportswomen appeared in Paris in 1900 following the decision by the organisers of the World’s Fair, of which the Olympic events formed part. The ﬁrst sports to accept both men and women were tennis, golf and croquet (1900), followed by archery (1904) and skating (1908), elite pursuits to which women were admitted subject to strict moral and social conventions. British tennis player Charlotte Cooper is known for being the ﬁrst female Olympic medallist. She was also a great champion of her time. But women were mainly present on the sidelines of the Games, giving demonstrations of gymnastics movements for hygiene and aesthetic purposes, presenting  “national” methods of strengthening the “races”. In 1912 in Stockholm, swimming and diving were added to the list of acceptable practices for women, whose status was akin to that of pretty water nymphs. As such, before the Great War, women’s participation had to meet the criteria of elegance, grace and beauty.  Alice Milliat and the emancipation of women through sport The situation of sportswomen evolved during the war. In 1915, a militant young Frenchwoman from a humble background became the ﬁrst leader to encourage women to practise sport and take part in competitions in the name of gender equality. Alice Milliat was born in Nantes in 1884 to a family of grocers. At the age of 20, she moved to London to become a private tutor for a well-to-do family, who took her with  1 Alice Milliat (left) was part of the refereeing committee for the track and ﬁeld events at Amsterdam 1928. 2 Milliatʼs campaigning was key in bringing womenʼs athletics to the Games for the ﬁrst time in 1928."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  them on their travels. She was also delighted to discover football, hockey, athletics and rowing, after the “dull hygienic” gymnastics lessons she had endured at school in France. This mind-broadening experience in another country would inspire her for the rest of her life. After marrying and then being widowed, with no children, Milliat moved to Paris before the war to ﬁnd work as a stenographer and interpreter. She joined the ﬁrst women’s club in the French capital, Fémina sport, founded in 1912, and became its president in 1915. She then led a transformation within the club, shifting the focus more to training and competition in various sports including football, traditionally an all-male bastion. For the French feminists of the time, sport was “a joyful movement which develops the physical and moral value of women”. And in particular, “sportswomen prove that when she cultivates her physical faculties, a woman ceases to be the ‘sick child’ over which so many crocodile tears have been shed”.* Milliat herself was a keen and outspoken writer, who advocated for gender equality and denounced “male domination” in numerous press articles that she published in the 1920s and ’30s. After becoming a member of the ﬁrst  2  31  Issue 120  national women’s sports federation, founded by men in 1917, she took over the presidency in 1919 and replaced the male leaders with women: as she saw it, the future of women’s sport had to be in the hands of sportswomen. It has to be said, though, that the male leaders of the French federations adapted well, and Milliat’s skilful use of the argument that sport was a tool for strengthening the “French race” won over even the most die-hard conservatives. As a result, women’s sport developed rapidly in France after the war. But Milliat’s ambitions for her sisters of the stadium went beyond her country’s borders.  Olympic athletics: a symbolic conquest Milliat’s dream was to get women admitted to the Olympic Games in their most emblematic sport: athletics. In 1926, she claimed that she had received a “formal no” from Coubertin in 1919, “and it was that which gave rise to the Women’s Games, which were ﬁrst held in Paris in 1922”†. Even if we have no written trace of this request, or his answer, the story seems believable. At the 1920 Games in Antwerp, nothing had changed for women compared with before the war, with around 60 women taking part in the competitions, just 2.4 per cent of  the athletes. A year later, after organising the ﬁrst international women’s athletics exchanges between France, Belgium, England, Switzerland and Czechoslovakia, Milliat created the International Women’s Sports Federation (FSFI), with the aim of validating sporting records, establishing the rules for women’s sports and organising competitions between countries, in particular four-yearly “Women’s Olympic Games”, like the IOC’s version for men. The ﬁrst edition was held in Paris, on 20 August 1922, and brought together 77 sportswomen from ﬁve countries to compete in 13 athletics events. The event was a sporting success, but it gave rise to numerous sexist reactions in the media, medical circles and, above all, the sports world. In France, as in the IOC, there were calls for the men’s federations to take back control over the organisation of women’s sport and rein in its development. In 1925, Coubertin stood down as IOC President and was succeeded by Belgian Count Henri de Baillet-Latour. And so it was no coincidence that Milliat’s FSFI decided to hold the second edition of its Games in Brussels, in the hope of attracting the attention, or even the goodwill, of the new President."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "32  Feature: Women at the Olympic Games  1  2  After the Belgian organisers desisted, the FSFI approached Gothenburg in Sweden, the home country of the powerful J. Sigfrid Edström, International Amateur Athletic Federation (IAAF) President and a member of the IOC Executive Board. The success of the second edition of these Games (renamed “Women’s World Games”) made the Swedish leader decide to take control of the development of women’s athletics. He proposed that women be allowed to compete in this sport at the 1928 Olympic Games in Amsterdam, but in just a few events, as an experiment; however, Milliat demanded the same level of participation as for the men. Parallel to this, Edström secretly convinced the IAAF’s national representatives to put a spanner in the works of the women’s National Federations, especially the one in France. But it took more than 10 years and the 1930s economic crisis in Europe to get Milliat to capitulate, exhausted by her struggle and by constantly having to seek funding.  1 Flor-Isava Fonseca was the ﬁrst female member of the IOC Executive Board. 2 Women made up 49 per cent of athletes at Tokyo 2020, the most gender-balanced Games in history.  In January 1935, Edström wrote to his American colleague and friend, Avery Brundage: “I suppose you know that Mme Milliat’s federation has caused us so much trouble that we certainly have no interest at all to support it. We should like the whole thing to disappear from the surface of the earth.”‡ A few months later, the FSFI dissolved itself despite four editions of the Women’s World Games and a constant increase in the number of both participants and member countries. Alice Milliat retired from public life and died unremarked in 1957.  A long marathon towards equality In 1942, the Swedish leader became IOC President following the death of Baillet-Latour, and his place was then taken in 1952 by Brundage, who led the organisation for 20 years. The result was that, throughout these two long terms of office, the percentage of female competitors at the Games remained low, increasing from 9.5 per cent in 1948 to just 14.6 per cent by 1972. And at a time when the position of women was at times still challenged by certain IOC Members, ostensibly to combat the excessive growth of the Games, the strongest support came from the Soviet  Union, ﬁrst allowed to be part of the Olympic competition in 1952. In the context of the Cold War, the USSR focused on the events neglected by the USA, especially the women’s competitions, in order to win as many medals as possible. As a result, the communist IOC Members constantly sought to add new events for women. They generally received short shrift, but after 1972 the new Irish IOC President, Michael Killanin, was more inclined to accept female athletes, in the context of social changes leading to greater gender equality. But the road ahead was still long. In 1981, his successor, Juan Antonio Samaranch, had the ﬁrst two female members co-opted into the IOC, in what was quite a revolution for the organisation. At the time, women represented just over 20 per cent of the athletes at the Games. It was the creation of a consultative “Women and Sport” working group in 1995 that really kick-started the process towards achieving parity in terms of participation, but also the creation of women’s events in all the Olympic sports. Since then, the IOC’s women in sport policy has become ambitious. The IOC’s historic position as the leading body of international sport gives it considerable leverage over international"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.png",
    "zoom": null,
    "content": "\n        <div class=\"addContentLinkThree\" style=\"top:730px;left:525px;height:19px;width:146px;\">\n          <a href=\"https://deloitte.com/olympics\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": "One Some Many All Together  Together, weíre making an impact. Through our management consulting expertise, weíre helping the IOC to ensure                   "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n\n        <div class=\"abs noOverflow\" style=\"top: 479px;left: 263px;height: 366px;width: 200px;\">\n          <img class=\"halfScale 34-bar-1\" style=\"top:350px;left:2px\" src=\"/120/static/_content/34-bar-1.png\"/>\n          <img class=\"halfScale 34-bar-2\" style=\"top:333px;left:30px\" src=\"/120/static/_content/34-bar-1.png\"/>\n          <img class=\"halfScale 34-bar-3\" style=\"top:296px;left:58px\" src=\"/120/static/_content/34-bar-1.png\"/>\n          <img class=\"halfScale 34-bar-4\" style=\"top:214px;left:87px\" src=\"/120/static/_content/34-bar-1.png\"/>\n          <img class=\"halfScale 34-bar-5\" style=\"top:116px;left:115px\" src=\"/120/static/_content/34-bar-1.png\"/>\n          <img class=\"halfScale 34-bar-6\" style=\"top:43px;left:144px\" src=\"/120/static/_content/34-bar-1.png\"/>\n          <img class=\"halfScale 34-bar-7\" style=\"top:1px;left:172px\" src=\"/120/static/_content/34-bar-1.png\"/>\n        </div>\n\n        <img class=\"halfScale 34-text-1\" style=\"top: 678px;left: 270px;\" src=\"/120/static/_content/34-text-1.png\"/>\n        <img class=\"halfScale 34-text-2\" style=\"top: 736px;left: 303px;\" src=\"/120/static/_content/34-text-2.png\"/>\n        <img class=\"halfScale 34-text-3\" style=\"top: 694px;left: 332px;\" src=\"/120/static/_content/34-text-3.png\"/>\n        <img class=\"halfScale 34-text-4\" style=\"top: 753px;left: 359px;\" src=\"/120/static/_content/34-text-4.png\"/>\n        <img class=\"halfScale 34-text-5\" style=\"top: 766px;left: 388px;\" src=\"/120/static/_content/34-text-5.png\"/>\n        <img class=\"halfScale 34-text-6\" style=\"top: 618px;left: 411px;\" src=\"/120/static/_content/34-text-6.png\"/>\n        <img class=\"halfScale 34-text-7\" style=\"top: 670px;left: 440px;\" src=\"/120/static/_content/34-text-7.png\"/>\n\n        <div class=\"abs noOverflow\" style=\"top: 479px;left: 490px;height: 366px;width: 200px;\">\n        <img class=\"halfScale 34-bar-8\" style=\"top:334px;left:2px\" src=\"/120/static/_content/34-bar-2.png\"/>\n        <img class=\"halfScale 34-bar-9\" style=\"top:251px;left:30px\" src=\"/120/static/_content/34-bar-2.png\"/>\n        <img class=\"halfScale 34-bar-10\" style=\"top:209px;left:58px\" src=\"/120/static/_content/34-bar-2.png\"/>\n        <img class=\"halfScale 34-bar-11\" style=\"top:69px;left:87px\" src=\"/120/static/_content/34-bar-2.png\"/>\n        <img class=\"halfScale 34-bar-12\" style=\"top:39px;left:116px\" src=\"/120/static/_content/34-bar-2.png\"/>\n        <img class=\"halfScale 34-bar-13\" style=\"top:23px;left:144px\" src=\"/120/static/_content/34-bar-2.png\"/>\n      </div>\n\n      <img class=\"halfScale 34-text-8\" style=\"top: 721px;left: 500px;\" src=\"/120/static/_content/34-text-8.png\"/>\n      <img class=\"halfScale 34-text-9\" style=\"top: 773px;left: 530px;\" src=\"/120/static/_content/34-text-9.png\"/>\n      <img class=\"halfScale 34-text-10\" style=\"top: 753px;left: 558px;\" src=\"/120/static/_content/34-text-10.png\"/>\n      <img class=\"halfScale 34-text-11\" style=\"top: 743px;left: 586px;\" src=\"/120/static/_content/34-text-11.png\"/>\n      <img class=\"halfScale 34-text-12\" style=\"top: 757px;left: 615px;\" src=\"/120/static/_content/34-text-12.png\"/>\n      <img class=\"halfScale 34-text-13\" style=\"top: 736px;left: 643px;\" src=\"/120/static/_content/34-text-13.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n\n          pg34Anim.fromTo(cOf(\"34-bar-1\"), 0.4, {y:20}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"34-bar-2\"), 0.4, {y:35}, {y:0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"34-bar-3\"), 0.4, {y:75}, {y:0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"34-text-1\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"34-bar-4\"), 0.4, {y:155}, {y:0, ease: Power2.easeOut}, 1.6)\n          .fromTo(cOf(\"34-text-2\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 1.6)\n          .fromTo(cOf(\"34-bar-5\"), 0.4, {y:265}, {y:0, ease: Power2.easeOut}, 1.8)\n          .fromTo(cOf(\"34-text-3\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 1.8)\n          .fromTo(cOf(\"34-bar-6\"), 0.4, {y:340}, {y:0, ease: Power2.easeOut}, 2)\n          .fromTo(cOf(\"34-text-4\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 2)\n          .fromTo(cOf(\"34-bar-7\"), 0.4, {y:380}, {y:0, ease: Power2.easeOut}, 2.2)\n          .fromTo(cOf(\"34-text-5\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 2.2)\n          .fromTo(cOf(\"34-bar-8\"), 0.4, {y:45}, {y:0, ease: Power2.easeOut}, 2.4)\n          .fromTo(cOf(\"34-text-6\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 2.4)\n          .fromTo(cOf(\"34-bar-9\"), 0.4, {y:125}, {y:0, ease: Power2.easeOut}, 2.6)\n          .fromTo(cOf(\"34-text-7\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 2.5)\n          .fromTo(cOf(\"34-bar-10\"), 0.4, {y:170}, {y:0, ease: Power2.easeOut}, 2.8)\n          .fromTo(cOf(\"34-text-8\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 2.6)\n          .fromTo(cOf(\"34-bar-11\"), 0.4, {y:310}, {y:0, ease: Power2.easeOut}, 3.0)\n          .fromTo(cOf(\"34-text-9\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 3)\n          .fromTo(cOf(\"34-bar-12\"), 0.4, {y:340}, {y:0, ease: Power2.easeOut}, 3.2)\n          .fromTo(cOf(\"34-text-10\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 3.2)\n          .fromTo(cOf(\"34-bar-13\"), 0.4, {y:355}, {y:0, ease: Power2.easeOut}, 3.4)\n          .fromTo(cOf(\"34-text-11\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 3.4)\n          .fromTo(cOf(\"34-text-12\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 3.6)\n          .fromTo(cOf(\"34-text-13\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 3.8)\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n        }\n      ",
    "searchText": "Feature: Women at the Olympic Games  and national institutions. Even though the IOC was for a long time reluctant to admit sportswomen, it has to be said that, today, it is succeeding where other cultural areas such as the media, cinema or music have still not really found solutions to combat sexism. ■ Florence Carpentier has been an associate professor at the University of Rouen (France) since 2004 where she teaches the history of sport and physical education. Since September 2018, she has been a senior researcher at the University of Lausanne (Switzerland). Her research focuses mainly on the history of the IOC and the Olympic Games. She also works on the emergence and development of women’s sport during the interwar period, in France and in the world. Carpentier is a researcher at the Centre for Studies of the  Carpentier Florence (2018), “Alice Milliat: A Feminist Pioneer for Women’s Sport”, in Emmanuel Bayle and Patrick Clastres (Eds.), Global Sport Leaders. A biographical Analysis of International Sport Management. Palgrave, pp. 61-81.  † Minutes of the 4th Congress of the FSFI, 27-29 August 1926, Göteborg (Sweden). Archives du Musée national du sport, Nice. ‡ Letter from Sigfried Edström to Avery Brundage, 3 January 1935, Avery Brundage Collection, IOC Archives, Lausanne.  Carpentier, Florence (2004), Le comité international olympique en crises. La présidence de Henri de Baillet-Latour (1925-1940). Paris, L'Harmattan.  50%  Milano Cortina 2026 – 47%  Beijing 2022 – 44.7%  Vancouver 2010 – 40.7%  Chamonix 1924 – 4.3%  Sarajevo 1984 – 21.5%  0%  Oslo 1952 – 15.7%  Olympic Winter Games  Paris 2024 – 50% First Olympic Games with equal representation  Olympic Summer Games  Atlanta 1996 – 34%  10%  Montreal 1976 – 20.7%  30%  London 2012 – 44.2% First Olympic Games with women participating in every sport  40%  20%  key  Carpentier, Florence (2019), “Alice Milliat et le premier ‘sport féminin’ dans l’Entre-deux-guerres”, 20&21. Revue d’histoire, n°142, pp. 93-107.  Carpentier Florence & Lefèvre Jean-Pierre (2006), “The Modern Olympic Movement, Women's Sport and the Social Order During the Interwar Period”, The International Journal of the History of Sport, Vol. 23, Issue 7, pp. 938-964.  London 1948 – 9.5%  For the ﬁrst time at the Olympic Games, Paris 2024 will achieve full gender parity on the ﬁeld of play with the same number of men and women set to compete in all sports. This is an important milestone and one that has been a long time in the making.  Carpentier, Florence (2022), “Les premiers jeux olympiques féminins (Paris, 1922). Internationalisme et droit de courir”, Revue d’histoire culturelle [online]  End notes * Jane Misme, “Pourquoi les sportives doivent-elles voter ?”, La Française, 10 March 1923.  Paris 1924 – 4.4%  female athletes at the games  Works by the author:  Transformations of Physical and Sports Activities at the University of Rouen and at the Global Sport & Olympic Studies Centre of the University of Lausanne. She is Secretary General of the European Committee for Sports History.  Paris 1900 – 2.2% First appearance at the Olympic Games  34"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "As a proud Olympic and Paralympic Partner, Airbnb recognizes the importance of feeling at home while training on the road.  “Thanks to the support from Airbnb, I was able to start my journey to Paris 2024 strong!” Olympic hopeful Surﬁng, USA  In partnership, the IOC and Airbnb are proud to be supporting athletes on their Olympic and Paralympic journey through the Airbnb500 and the Airbnb Athlete Travel Grant programs."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 36-title-1\" style=\"top:152px;left:42px\" src=\"/120/static/_content/36-title-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim.fromTo(cOf(\"36-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 0.9)\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "36  Feature: Then and now  parIs: an olympIc host 100 years apart D  espite the century separating them, the 1924 and 2024 Olympic Games share not only the same city but some of the same venues. Paris 1924 was the ﬁrst time athletes stayed together at an Olympic Village, in the suburb of Colombes. The athletes of 2024 will stay just a few kilometres to the east, within a 51-hectare site lying between the communes of Saint-Denis, Île-Saint-Denis and Saint-Ouen. Twenty-one Olympic and 14 Paralympic venues will be located within 10km of the Village, with more spread around the Île-de-France region. Versailles, for example, which hosted the shooting events in 1924, will stage equestrian and modern pentathlon. Similarly, Stade Olympique de Colombes – now known as Stade Yves-du-Manoir – site of the 1924 Opening and Closing Ceremonies and various sports, will host hockey next summer. Explore a century of Paris’s Olympic landscape and iconic landmarks by switching between the maps of Paris 1924 and 2024, using the key to compare the sites of the competition venues.  key: 1924 and 2024 sports 21 Athletics (marathon ﬁnish)  39 Rowing  2 Taekwondo  22 Badminton  40 Canoe slalom  3 Athletics (race walk)  23 Gymnastics (rhythmic)  41 Canoe sprint  4 Cycling (road)  24 Aquatics (water polo)  42 Sailing  1  Fencing  5 Beach volleyball  43 Polo  6 Tennis  25 Aquatics (artistic swimming)  44 Shooting  7 Boxing  26 Aquatics (diving)  45 Cycling (mountain bike)  8 Football  27 Rugby  46 Cycling (track)  9 Volleyball  28 Athletics  47 Cycling (BMX racing)  10 Table tennis  29 Basketball (3×3)  48 Golf  11 Handball  30 Breaking  49 Equestrian (jumping)  12 Weightlifting  31 Cycling (BMX freestyle)  50 Equestrian (dressage)  13 Judo  32 Skateboarding  51 Equestrian (eventing)  14 Wrestling  33 Hockey  52 Surﬁng  15 Cycling (individual time trial start)  34 Cycling (individual time trial ﬁnish)  53 Sport climbing  16 Archery  35 Triathlon  17 Athletics (marathon start)  36 Aquatics (marathon swimming)  18 Gymnastics (artistic) 19 Gymnastics (trampoline) 20 Basketball  1924 and 2024  54 Art competitions  37 Aquatics (swimming) 38 Modern pentathlon  1924  2024"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 37-title-1\" style=\"top:802px;left:43px\" src=\"/120/static/_content/37-title-1.png\">\n\n      <img class=\"halfScale 37-img\" style=\"top:503px;left:75px\" src=\"/120/static/_content/37-img-1.png\">\n      <img class=\"halfScale 37-img\" style=\"top:419px;left:158px\" src=\"/120/static/_content/37-img-2.png\">\n      <img class=\"halfScale 37-img\" style=\"top:501px;left:196px\" src=\"/120/static/_content/37-img-3.png\">\n      <img class=\"halfScale 37-img\" style=\"top:722px;left:209px\" src=\"/120/static/_content/37-img-4.png\">\n      <img class=\"halfScale 37-img\" style=\"top:565px;left:296px\" src=\"/120/static/_content/37-img-5.png\">\n      <img class=\"halfScale 37-img\" style=\"top:676px;left:516px\" src=\"/120/static/_content/37-img-6.png\">\n      <img class=\"halfScale 37-img\" style=\"top:565px;left:625px\" src=\"/120/static/_content/37-img-7.png\">\n      <img class=\"halfScale 37-img\" style=\"top:277px;left:568px\" src=\"/120/static/_content/37-img-8.png\">\n      <img class=\"halfScale 37-img\" style=\"top:477px;left:523px\" src=\"/120/static/_content/37-img-9.png\">\n      <img class=\"halfScale 37-img\" style=\"top:308px;left:426px\" src=\"/120/static/_content/37-img-10.png\">\n      <img class=\"halfScale 37-img\" style=\"top:423px;left:308px\" src=\"/120/static/_content/37-img-11.png\">\n      <img class=\"halfScale 37-img\" style=\"top:287px;left:120px\" src=\"/120/static/_content/37-img-12.png\">\n      <img class=\"halfScale 37-img\" style=\"top:247px;left:229px\" src=\"/120/static/_content/37-img-13.png\">\n      <img class=\"halfScale 37-img\" style=\"top:163px;left:224px\" src=\"/120/static/_content/37-img-14.png\">\n      <img class=\"halfScale 37-img\" style=\"top:116px;left:186px\" src=\"/120/static/_content/37-img-15.png\">\n      <img class=\"halfScale 37-img\" style=\"top:130px;left:122px\" src=\"/120/static/_content/37-img-16.png\">\n    ",
    "script": "\n      function onPageEnter() {\n        pg37Anim = new TimelineMax();\n        pg37Anim.fromTo(cOf(\"37-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n        .staggerFromTo(cOf(\"37-img\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.1)\n      }\n\n      function onPageLeave() {\n        pg37Anim.stop();\n        removeContentLinks();\n      }\n    ",
    "searchText": "venues outsIde parIs elancourt hIll  saInt-quentIn-enyvelInes velodrome and bmx stadIum  45  46 47  la concorde  stade de france  aquatIcs centre 24  29  27  golf natIonal  ch‚teau de versaIlles  30  28  48  38  31  49  32  Paris-Charles de Gaulle airport  25 26 Paris-Le Bourget airport  50 51  pont alexandre III  le bourget sport clImbIng venue  34  53  35 north parIs arena 36  7  33  olympIc vIllage  yves-du-manoIr stadIum  38  porte de la chapelle arena 22 23  grand palaIs  parIs la dÈfense arena  vaIres-sur-marne nautIcal stadIum  1  24  2  39  37  40 41 pont díIÈna 3 4 hÙtel de vIlle eIffel tower stadIum  17  5  champ-de-mars arena roland-garros stadIum 6  InvalIdes  13  15  14  16 21  7  parc des prInces 8  south parIs arena  bercy arena  9  18 19  10 11  Paris-Orly airport  12  parIs 2024  20"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 38-title-1\" style=\"top:802px;left:43px\" src=\"/120/static/_content/38-title-1.png\">\n\n        <img class=\"halfScale 38-img\" style=\"top:408px;left:309px\" src=\"/120/static/_content/38-img-1.png\">\n        <img class=\"halfScale 38-img\" style=\"top:486px;left:102px\" src=\"/120/static/_content/38-img-2.png\">\n        <img class=\"halfScale 38-img\" style=\"top:539px;left:57px\" src=\"/120/static/_content/38-img-3.png\">\n        <img class=\"halfScale 38-img\" style=\"top:618px;left:53px\" src=\"/120/static/_content/38-img-4.png\">\n        <img class=\"halfScale 38-img\" style=\"top:633px;left:96px\" src=\"/120/static/_content/38-img-5.png\">\n        <img class=\"halfScale 38-img\" style=\"top:643px;left:280px\" src=\"/120/static/_content/38-img-6.png\">\n        <img class=\"halfScale 38-img\" style=\"top:564px;left:302px\" src=\"/120/static/_content/38-img-7.png\">\n        <img class=\"halfScale 38-img\" style=\"top:556px;left:377px\" src=\"/120/static/_content/38-img-8.png\">\n        <img class=\"halfScale 38-img\" style=\"top:601px;left:502px\" src=\"/120/static/_content/38-img-9.png\">\n        <img class=\"halfScale 38-img\" style=\"top:526px;left:471px\" src=\"/120/static/_content/38-img-10.png\">\n        <img class=\"halfScale 38-img\" style=\"top:324px;left:473px\" src=\"/120/static/_content/38-img-11.png\">\n        <img class=\"halfScale 38-img\" style=\"top:294px;left:437px\" src=\"/120/static/_content/38-img-12.png\">\n        <img class=\"halfScale 38-img\" style=\"top:223px;left:497px\" src=\"/120/static/_content/38-img-13.png\">\n        <img class=\"halfScale 38-img\" style=\"top:88px;left:500px\" src=\"/120/static/_content/38-img-14.png\">\n        <img class=\"halfScale 38-img\" style=\"top:88px;left:455px\" src=\"/120/static/_content/38-img-15.png\">\n        <img class=\"halfScale 38-img\" style=\"top:87px;left:372px\" src=\"/120/static/_content/38-img-16.png\">\n        <img class=\"halfScale 38-img\" style=\"top:229px;left:330px\" src=\"/120/static/_content/38-img-17.png\">\n        <img class=\"halfScale 38-img\" style=\"top:224px;left:252px\" src=\"/120/static/_content/38-img-18.png\">\n        <img class=\"halfScale 38-img\" style=\"top:409px;left:58px\" src=\"/120/static/_content/38-img-19.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.fromTo(cOf(\"38-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .staggerFromTo(cOf(\"38-img\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.1)\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "lIlle  metropolItan france  11 20  parIs  Just like in 1924, when events were held across France in locations such as Le Havre and Reims, Paris 2024 is involving the entire country as part of its vision of a “Games wide open” and showing the world the best France has to offer. The sailing will take place on the waters of the Mediterranean nantes in Marseille; the football 8 kicks off at seven famous stadiums in regions across the country; while in the north Lille will host ch‚teauroux basketball’s qualiﬁcation 44 games and handball’s ﬁnal-phase games. The medals for the 15 shooting events, meanwhile, will be contested in the heart of France, at the world-class CNTS shooting centre in Châteauroux.  lyon 8  st-ÈtIenne 8  nIce bordeaux 8  8 marseIlle 8 42  overseas terrItorIes Boasting a world-renowned surf break and spectacular surroundings, Teahupo’o in Tahiti will provide a magniﬁcent setting for surﬁng’s second Olympic appearance. As well as offering competitors optimum conditions and the chance to tackle one of surﬁng’s dream locations, the waves at Teahupo’o represent Paris 2024’s aim to involve the whole of France in the Games, showcasing its rich and diverse heritage and engaging the communities of French Polynesia.  teahupoío 52"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 39-img\" style=\"top:135px;left:354px\" src=\"/120/static/_content/39-img-1.png\">\n        <img class=\"halfScale 39-img\" style=\"top:281px;left:217px\" src=\"/120/static/_content/39-img-2.png\">\n        <img class=\"halfScale 39-img\" style=\"top:315px;left:208px\" src=\"/120/static/_content/39-img-3.png\">\n        <img class=\"halfScale 39-img\" style=\"top:375px;left:379px\" src=\"/120/static/_content/39-img-4.png\">\n        <img class=\"halfScale 39-img\" style=\"top:437px;left:532px\" src=\"/120/static/_content/39-img-5.png\">\n        <img class=\"halfScale 39-img\" style=\"top:419px;left:589px\" src=\"/120/static/_content/39-img-6.png\">\n        <img class=\"halfScale 39-img\" style=\"top:350px;left:543px\" src=\"/120/static/_content/39-img-7.png\">\n        <img class=\"halfScale 39-img\" style=\"top:311px;left:553px\" src=\"/120/static/_content/39-img-8.png\">\n        <img class=\"halfScale 39-img\" style=\"top:114px;left:462px\" src=\"/120/static/_content/39-img-9.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim.staggerFromTo(cOf(\"39-img\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)\n        }\n\n        function onPageLeave() {\n          pg39Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "stade olympIque de colombes 3  4  8  17  venues outsIde parIs  stade de tennIs de colombes 6  camp de ch‚lons/ stand olympIque de ch‚lonssur-marne  palaIs de la socIÈtÈ des rÈgates du havre  hIppodrome du grand parquet  parc des sports de reIms/stand de la socIÈtÈ de tIr de reIms/stade olympIque de reIms  44  42  38  44  olympIc vIllage  18 21 27 28 38 49 50 51 bassIn díargenteuIl cercle de la voIle de parIs, meulan  39 stade nautIque des tourelles/ pIscIne des tourelles  42  24 26  stade de parIs  37 38  8 stade díescrIme de colombes 1  terraIn de polo de bagatelle  grand palaIs 54  43  hIppodrome díauteuIl  saInt-cloud golf club  51  43  8 stade bergeyre stade pershIng 8  vÈlodrome díhIver 1  7  12 14 vÈlodrome munIcIpal de vIncennes stand de versaIlles  auteuIl-vIllacoublay  38 44  51  stand díIssyles-moulIneaux 44  parIs 1924  46"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 40-title-1\" style=\"top:108px;left:43px\" src=\"/120/static/_content/40-title-1.png\">\n        <img class=\"halfScale 40-sub-1\" style=\"top:177px;left:42px\" src=\"/120/static/_content/40-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.fromTo(cOf(\"40-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"40-sub-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "a home away from home A CENTURY ON FROM WHEN IT FIRST APPEARED AT A GAMES, THE OLYMPIC VILLAGE REMAINS AN ICONIC PART OF THE GAMES-TIME EXPERIENCE, WHILE ITS PURPOSE AND LEGACY CONTINUE TO EVOLVE. BY CONOR KETLEY  1  2  W  hile the ﬁrst iterations of the modern Olympic Games brought athletes together on the ﬁeld of play, there was no official plan in place to host those who travelled to compete. The ﬁrst Olympic Village, built for Paris 1924, changed that. These Games saw small wooden huts house the majority of athletes just a few minutes’ walk away from the Stade Olympique de Colombes in north-west Paris, where many of the events took place. This temporary accommodation, while proving practical in providing a convenient location  for athletes to stay, was largely motivated by a desire to bring participants together under one roof, and also featured a post office, bureau de change and a restaurant. “In bringing young people from every nation together, [the Olympic Games] help foster this sense of cordiality that teaches men to become acquainted with each other better ﬁrst and then to hold each other in higher esteem, a process that the Paris Games will have greatly aided.” These are the words of Frantz Reichel, Secretary General of the Organising Committee of the Olympic"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "41  3  More than just accommodation  Games Paris 1924, in the Official Report of the Games. Reichel wrote this part of his report to emphasise the growth of the Olympic Movement since the inaugural Olympic Congress in 1894, but in the century since, the Olympic Village has taken on an even bigger role in uniting the Olympic Movement.  For most cities that host the Olympic Games, it would probably be possible to accommodate Games participants in private lodgings through hotels, for instance, but the Olympic Village has become such an iconic part of the Games-time experience for athletes that it is now impossible to imagine the event without it. Increasingly over time, the Village has proven itself to be the true melting pot of the Games. A total of 205 nations and the IOC Refugee Olympic Team were represented at Tokyo 2020, and the Village acts as a space where athletes can come together away from the spotlight and make friendships that will last a lifetime. “If you get rid of the Olympic Village, you get rid of a part of the Games,” says Henri Specht, Director of the Olympic and Paralympic Village project at SOLIDEO, the civil engineering ﬁrm developing the Village. “It’s probably the only place and the only time on the planet when you have so many countries coming together at the same location. I think that every nation is very attached to the Village and the athletes who have lived in it have come out with a unique life experience.”  Evolution of the Village 1 Following the conclusion of the Games, the Olympic Village will become home to 6,000 Parisian residents. 2 The ﬁrst Olympic Village at Paris 1924 saw the construction of temporary accommodation. 3 The Village site will develop three communes in northern Paris along the river Seine.  As the social impact for those living within the Village during the Games has grown over time, so too has the social impact for those outside it. Paris 2024 offers a genuine opportunity to develop an area of the French  capital into a modern space, with accessibility and environmental impact taken into account. As has been the case in other recent editions of the Games, one major difference between Paris 2024 and Paris 1924 is that the Olympic Village is now built with the future in mind. No longer is the objective to house athletes for a few weeks and consequently remove temporary infrastructure, but to create a lasting impact that will beneﬁt locals. The Olympic Village will be located seven kilometres north of the centre of Paris in the communes of Saint-Denis, Île-Saint-Denis and Saint-Ouen, less than ﬁve minutes away from the Stade de France. Seven of the 51 hectares it covers will be dedicated to green space, including a public park at its heart, and some 9,000 trees and bushes have been planted within the Village. “Above all, for us the Olympic Village is about urban development,” says Specht. “The heritage side of the programme is our top priority. And we want to use the Games to cater to as many different people as possible.” The ﬁrst part of the Olympic Village’s journey will both begin and end in the summer of 2024, but the next chapter begins one year later, when it is planned that the space will be open for 6,000 inhabitants to beneﬁt from the Village’s new lease of life. The truth is that while the Olympic and Paralympic Games are the raisons d’être of the Olympic Village, the legacy from which the host city will beneﬁt is now just as much of a focus. ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <img id=\"42-title-1\" class=\"halfScale\" style=\"top:123px;left:133px\" src=\"/120/static/_content/42-title-1.png\"/>\n        <img id=\"42-title-2\" class=\"halfScale\" style=\"top:317px;left:133px\" src=\"/120/static/_content/42-title-2.png\"/>\n        <img id=\"42-sub-1\" class=\"halfScale\" style=\"top:240px;left:137px\" src=\"/120/static/_content/42-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim.fromTo(idOf(\"42-title-1\"), 0.8, {opacity:0, y:-40},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"42-title-2\"), 0.8, {opacity:0, y:40},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"42-sub-1\"), 0.4, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop();\n          removeContentLinks();\n      }\n      ",
    "searchText": "through NEXT SUMMER WILL MARK A CENTURY OF PROGRESS AND DEVELOPMENT SINCE PARIS 1924. HERE, OLYMPIC REVIEW TAKES A PICTORIAL LOOK AT THE EVOLUTION OF THE GAMES  the lens  01  01.  The Pont Alexandre III, with its four emblematic golden bronze statues, connects Invalides and the Grand Palais across the river Seine.  02.  The iconic landmark will host multiple events at Paris 2024 such as the marathon swimming and triathlon."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01 02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "03 04 01.  Spectators look on from the stands at Paris 1924.  02.  Breaking is one of the new urban sports set to debut at Paris 2024, marking a clear evolution of the sports programme at the Games.  03.  A French gymnast performs at a pre-Games celebration near the Pont Alexandre III.  04.  The men's 10m platform diving event at Paris 1924 at the Piscine des Tourelles."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01  01.  Two Japanese athletes relax at the ﬁrst-ever Olympic Village, located near the Stade de Colombes.  02.  Finland’s Ville Ritola and Frenchman Paul Bontemps tackle the water jump in the 3,000m steeplechase ﬁnal.  02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "omegawatches.com  R E C O R D I N G O LYM P I C D R E A M S Since 1932, OMEGA has known that the Olympic Games is a stage for dedicated athletes to reach              Timekeeper and why weíre so passionate about providing trusted precision in every single event."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01  01.  BMX freestyle will make a return at Paris 2024, after its success at the previous edition of the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "50  Through the lens  01  01.  France’s tandem gold medallists at the Olympic Games Paris 1924: Jean Cugnot and Lucien Chouly.  02.  Wireless broadcasting station inside the track at the Stade de Colombes.  03.  Children take a skateboarding lesson at a newly-opened Terre de Jeux skatepark in Pontoise, north-west Paris.  02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "03"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 52-title\" style=\"top:517px;left:44px\" src=\"/120/static/_content/52-title-1.png\"/>\n\n        <img \n          class=\"abs halfScaleC halfpulse animatedpulse pointer\" \n          style=\"top:439px; left:33px;\"\n          onclick=\"pg52_gallery(0)\" \n          src=\"/120/static/_content/white-camera.png\"\n        />\n      ",
    "script": "\n        function onPageEnter() {\n          pg52Anim = new TimelineMax();\n          pg52Anim.fromTo(cOf(\"52-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg52Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "games for a new era"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 53-sub\" style=\"top:110px;left:341px\" src=\"/120/static/_content/53-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg53Anim = new TimelineMax();\n          pg53Anim.fromTo(cOf(\"53-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg53Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "IN ONE YEAR, FRANCE AND PARIS WILL HOST THE OLYMPIC SUMMER GAMES. IN DOING SO, PARIS WILL JOIN LONDON (1908, 1948 AND 2012) AND LATER BE JOINED BY LOS ANGELES (1932, 1984 AND 2028) AS THREE-TIME HOST CITIES. BY ALAIN LUNZENFICHTER  Paris 2024 will break new ground by taking sports events into the heart of the city."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1  S  ince the Paris Games of 1900 and 1924, this great sporting festival has changed signiﬁcantly, and organising the event today is a very different beast. The proﬁle and wider impact the Olympic Games enjoy in the 21st century is barely comparable with the situation at the start of the previous century. Put simply, the world has changed, sport has changed and the IOC has changed – meaning the Olympic Games have also changed. The ﬁgures speak for themselves: we’re no longer in the same world, no longer on the same sporting planet. Back in 1924, the event was still very much in its infancy; today, it is the equivalent of 32 world championships taking place at the same time, the vast majority in the same city. Back then, much of the event was  concentrated around facilities belonging to a single club, the Racing Club de France. One of the biggest clubs in the world, granted, but a scenario that would no longer be possible today: multiple venues are required, which only a country can provide. While Paris 1924 was the ﬁrst edition to feature an Olympic Village, a number of participants were still put up in hotels. Paris 2024, on the other hand, has set up an Olympic Village that will accommodate more than 15,000 people. The primary venue at the 1924 Games, the Stade de Colombes, will nevertheless once again have the privilege of hosting a sports competition one century on: hockey. The renovated Yves-du-Manoir Stadium (as it is officially known) will also have a post-Games legacy, as it is set to become the headquarters of the French Hockey Federation.  Impressive numbers The record-breaking numbers seen in the post-Great War period have been far surpassed today. The Olympic Games, once the bastion of amateur sport, have moved triumphantly into the professional era and gone truly global. In 1924, the athletes came from 45 countries, 27 of which were European; in 2024, Europe will no longer be the continent sending the most nations to the “City of Light”. The number of athletes set to compete – 10,500 – is also a world away from the 3,089 who took part in 1924. Another major development next year will see advances in the participation of female athletes (135 competed in 1924)*. Olympic Agenda 2020, adopted in 2014 at the IOC Session in Monaco, marked a real turning point in this respect: the Olympic Games in"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://youtu.be/ay4ghAR1DD0\" target=\"_blank\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:256px;top:551px\" src=\"/120/static/_content/white-play.png\"/>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  55  Issue 120  Paris next year will be gender-equal for the ﬁrst time in history, with the same number of men and women (5,250) competing in 329 events across 32 sports. Over the past century, opportunities for travel have also increased dramatically as travel itself has become global, signiﬁcantly changing things for spectators attending the event. In 1924, there were around 600,000 spectators over the course of the Games, though it’s impossible to know how many of those in Paris between 5 and 24 July 1924 came from abroad. This time, almost 10 million tickets are on sale for spectators all over the world – 13.5 million if we include the Paralympic Games, which didn’t exist in 1924. But what has revolutionised the scale of the Olympic Games more than anything has been the increasingly important role of the media. For decades, the market consisted solely of the written press and photo journalists. The advent of radio provided a platform for the Olympics to develop a voice from 1924 – this helped create suspense and capture the public imagination, as images of the sporting action were painted through words. Since then, television has taken the Games to a whole new level. While there were only 685 journalists in attendance in 1924 – including a small number of women – more than 25,000 media personnel (mostly from television) will be present next year, and the Games, broadcast in more than 220 countries and territories, will be beamed into households across the planet. Therein, in fact, lies their success: while the 1924 Olympics were essentially for a French audience, Paris 2024 will be watched throughout the world. And in another major development, a village has been built specially for the media, a stone’s throw away from Paris-Le Bourget Airport and the Stade de France. A century on, then, the Games are completely different. A hundred years ago, they were simply an international sports event. Now – and throughout the 10 years or so between the start of the candidature phase and the Games next year – the aim has been  1 Paris 2024 seeks to encourage young people to take up sport. 2 Between 140 and 170 barges will transport athletes along the river Seine in the Opening Ceremony.  to make sure every person in France feels part of the process. Many other towns and cities will have the privilege of hosting events; Paris 2024 will be Games not just for the capital, but for the whole of France. Marseille, Châteauroux, Lille and even Tahiti will stage Olympic competitions, although most events will be taking place in Paris and the Paris region. The day after the Olympic ﬂag was handed over to the city of Paris, a team from Paris 2024 began a journey across France with three ﬂags, featuring the Olympic rings, the Paralympic Agitos and, of course, the Paris 2024 emblem. This was just the ﬁrst stage in the Olympic adventure. The second came in the shape of “Terre de Jeux 2024”, a label designed to connect people and groups involved in sport – from National Federations and local organisations to French embassies – to encourage joint projects and make sure the Games engage the country as a whole. Paris 2024 President Tony Estanguet said of the label: “My ambition is for us to use the Games to further strengthen the position of sport within society, and to achieve this, we must engage with all regions. The driving forces for increasing the reach of sport in this country are all the small towns, where we all started out.”  2  Olympic Day on 23 June has also been harnessed to generate enthusiasm for sport and the Games across France. Sporting greats have taken part in the various editions, sharing their passion and interacting with members of the public, while participants have been able to enjoy all manner of sports demonstrations. And as part of the “Terre de Jeux 2024” programme, a global 24-hour sports relay was organised, starting in New Zealand and ending in Tahiti, to mark the 500-day countdown to Paris 2024.  Half a million spectators for the Opening Ceremony In a historic ﬁrst, and a departure from previous editions, the Paris Opening Ceremony won’t be taking place inside the Olympic Stadium. With Artistic Director Thomas Jolly – Director of the Quai National Drama Centre in Angers, known for his 18-hour production of Shakespeare’s Henry VI at the Odéon theatre and a new version of Starmania – at the helm, the Opening Ceremony is set to light up the river Seine. Paris 2024 is breaking new ground by taking sports competitions into the city; the same will be true of the Opening Ceremony. With 140 to 170 barges transporting the national delegations, the athletes’ parade"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "56  Feature: Rendez-vous in Paris in 2024  will wend its way down a 6km stretch of the river between the Austerlitz bridge and the Trocadéro, where the ﬁnal shows and protocol ceremonies will take place. The boats will be equipped with multiple cameras so that TV and online viewers can see the athletes up close. While around 60,000 spectators normally attend the Opening Ceremony, at least eight times as many will be present on the banks of the Seine, and more than 80 per cent will be able to attend free of charge. Eighty giant screens throughout Paris will allow everyone to follow the ceremony live. As for where the Olympic cauldron, containing the ﬂame that will burn throughout the Games, could go, Jolly certainly has a few ideas. “Leaving it on the water, like a ﬂoating candle, would be beautiful. But the ﬂame needs to be big and mobile, and resemble the emblem. The city will become the real-life backdrop for this unique event, and the various tableaux will showcase the monuments, bridges and cultural establishments along the banks of the Seine.” While the Games will attract spectators from all over the world, there will also be places where people who haven’t been able to get tickets can follow the competitions: the fan zones, which of course didn’t exist in 1924; and especially Parc de la Villette, where “Club France” will be based, and which will be one of the official Live Sites next summer, with 200 hours of sports action being broadcast live. The park will be able to welcome between 50,000 and 100,000 people every day, and an extraordinary atmosphere is guaranteed.  1  Organising festive Games has been the guiding principle for Paris ever since the candidature phase – Games that break the mould and use monuments in the city and suburbs as the backdrop for competitions. Sport will be everywhere in Paris: fencing and taekwondo at the Grand Palais, beach volleyball at the Eiffel Tower, triathlon swimming in the Seine, and equestrian and modern pentathlon at the Château de Versailles. And the Organising  Committee has decided that the urban sports and disciplines, featuring some of the younger participants, will be best served by being moved out of the more traditional arenas and into the very heart of the city. For more or less the duration of the Games, from 27 July to 10 August, Place de la Concorde will play host to BMX freestyle, breaking, skateboarding and 3×3 basketball. For the ﬁrst time in Olympic history, athletics and cycling, two of the major sports, will have events that are open to the general public, who will therefore be able to say that they have taken part in the Games. One of these mass participation events is the marathon, which will follow a symbolic route, on a looped circuit between Paris and Versailles, that ties into France’s revolutionary history. On 5 and 6 October 1789, with the capital suffering from bread shortages, between 6,000 and 7,000 women set out from Paris City Hall and marched on  1 The historic Grand Palais will host the fencing and taekwondo competitions. 2 The men’s and women’s golf competitions will take place at the prestigious Golf National. 3 The mascots for the Games – the “Phryges” – are a symbol of freedom."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.png",
    "zoom": null,
    "content": "\n        <a href=\"https://fb.watch/lB834ma5O3/\" target=\"_blank\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:255px;top:348px\" src=\"/120/static/_content/white-play.png\"/>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  Issue 120  2  For the first time in Olympic history, athletics and cycling will have events that are open to the general public Versailles, to make Louis XVI aware of their plight and demand reforms – which led to the ratiﬁcation of the Declaration of the Rights of Man and of the Citizen and saw the King return to the Tuileries. The Paris stretch of the route will also take runners past the Palais Garnier opera house and the Louvre pyramid. Double Olympic marathon champion, Kenya’s Eliud Kipchoge, himself came to the capital to launch the event. For those who don’t feel they have done the training to tackle the marathon’s 42.195km, a 10km run will also be open to the public. The other mass participation event will be a cycling race, which will take place in Parc de la Courneuve, not far from the Stade de France. The revolutionary spirit is also reﬂected in the Paris 2024 mascots. Unlike most editions since 1972, the Organising Committee decided not to select an animal as the  3  mascot, opting instead for the “Phryges”. An unorthodox choice to many foreign onlookers, but very much in keeping with the tone Paris 2024 organisers wanted, the “Phryges” are based on an item of clothing that is a symbol of freedom, has been part of history for centuries, and dates back to ancient times. Having featured on certain ﬂags in Latin America before being widely popularised by French revolutionaries, the Phrygian cap has now become a familiar symbol in France. It is a symbol of revolutions, the French Republic and freedom, and can be seen on the French national icon, Marianne, depicted in busts at town halls and on stamps. The National Archives show records of Phrygian caps being worn during the construction of Paris’s Notre-Dame cathedral in 1163.  Sustainable Games Faced with the environmental and social issues of the 21st century – humanity’s greatest challenge – the world of sport needs to assume its share of responsibility. By halving Games-related emissions and offsetting more than the CO2 emissions generated, the Paris 2024 Games will be sustainable in a way never seen before. And  because the Games provide an opportunity to think bigger and look to the future, they have to help pick up the pace of the environmental transition in sport, regions across France and major events. This is why the city of Paris will be opening 60km of cycling lanes to link all the competition venues, complete with dedicated route signage. The lanes closest to the venues will be decorated with the Games pictograms and colours. These Olympic lanes will be kept as a post-Games legacy, becoming part of the daily lives of Paris residents. The Olympic lanes, and the many other innovations, are all part of the transformation of Paris which, in one year’s time, will play host not just to a sporting event, but an experience for everyone – athletes, spectators, residents and the watching world. Over the following pages, we speak to some of the leading ﬁgures who are playing central roles in delivering the city’s vision for the Games, and beyond. ■  End notes * Note that these figures can vary slightly depending on the historical documents consulted."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 58-line-1\" style=\"top:176px;left:45px\" src=\"/120/static/_content/58-line-1.png\"/>\n        <img id=\"58-quote-1\" class=\"halfScaleC\" style=\"top:84px;left:11px\" src=\"/120/static/_content/58-quote-1.png\"/>\n        <img class=\"halfScale 58-line-1\" style=\"top:176px;left:45px\" src=\"/120/static/_content/58-line-1.png\"/>\n        <img class=\"halfScale 58-title-1\" style=\"top:178px;left:84px\" src=\"/120/static/_content/58-title-1.png\"/>\n        <img id=\"58-img-1\" class=\"halfScaleC\" style=\"top:189px;left:-75px\" src=\"/120/static/_content/58-img-1.png\"/>\n        <img class=\"halfScale 58-sub-1\" style=\"top:626px;left:83px\" src=\"/120/static/_content/58-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg58Anim = new TimelineMax();\n          pg58Anim\n            .fromTo(cOf(\"58-line-1\"), 0.6, {opacity:0, y:40},{opacity:1, y:0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"58-quote-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(cOf(\"58-title-1\"), 0.6, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut}, 1.3)\n            .fromTo(idOf(\"58-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)\n            .fromTo(cOf(\"58-sub-1\"), 0.6, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut}, 1.5)\n        }\n\n        function onPageLeave() {\n          pg58Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ì  weíre on schedule  1  W michel cadot is a senior civil servant who became Prefect of Paris after serving in a number of similar roles outside the capital. He was named Interministerial Delegate for the 2024 Olympic and Paralympic Games and Interministerial Delegate for Major Sports Events on 17 August 2020.  e’re on schedule. We’ve made very sound progress with the Games preparations, as we now have the governance system ﬁrmly in place with the French President and the Prime Minister, who holds regular meetings with the ministers involved in the project. There’s very good coordination between the central government, the Organising Committee for the Olympic Games (OCOG) and the prefectures at local level. As far as we’re concerned, we want to make sure that the deadlines are met and the various milestones are successfully achieved. We’re on schedule and on budget with the infrastructure delivery. There are 64 projects being monitored, and everything’s progressing well. The OCOG has stepped up the pace in signing deals and organising test events. The Olympic bill was approved by a signiﬁcant majority in parliament. Over the next few months, there’s going to be huge"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "59  engagement around security, transport and mobility issues. All the internal security forces need to be mobilised, and we have to ﬁnalise the security plans for every competition. The scale of the operation in Île-de-France is much bigger than it was for the Euro 2016 football championships, for example. It’s going to be 10 times as big in terms of time, security guarantees, and the overall operation to ensure a secure open-air zone for the Opening Ceremony on the river Seine. Cybersecurity is a separate matter, which raises technology and legal issues. Previous editions of the Olympic Games have shown how this is an area that can pose major challenges. We’re going to use the opportunity of the Rugby World Cup (held in France in September and October this year) to bolster the state’s service apparatus. Accommodation also needs to be found for the 25,000 extra security personnel in Île-de-France alone. Above all, it’s important to build real engagement among the population, through  Live Sites across the country and strong turnout in the stadiums. The government has taken the necessary steps in this regard by purchasing a large of number of tickets, which will be redistributed to as many people as possible. The Torch Relay should also be seized as an opportunity for celebration. The legacy will ultimately be measured at the end of the Games. We’ve planned to do this through pre- and post-Games impact studies. I’d say that our primary intention is to get tangible, economic beneﬁts, in particular through the 64 renovation, redevelopment and construction projects across France, from Marseille to Lille and Châteauroux. This also includes a government plan to provide funding for 5,000 local facilities – which will obviously remain after the event. But there’ll also be a considerable economic impact in the employment market: special focus will be given to helping secure employment opportunities for the economically inactive population in small and medium-sized businesses, especially  in Seine-Saint-Denis. There will be an impact on tourism too, with tourist numbers clearly going to be higher than previous years, and the Seine-Saint-Denis department itself will be transformed, particularly the Saint-Denis, Saint-Ouen, l’Île-Saint-Denis, Dugny, La Courneuve and Le Bourget areas. The legacy left by the Olympic Village will be that of an innovative, ambitious urban neighbourhood: it will become an eco-friendly, mixed neighbourhood with social housing and affordable accommodation for 6,000 residents, office buildings and seven hectares of green open spaces. It will also be carbon neutral. This will be the case for the Media Village in Dugny, too. All of this will help enhance the attractiveness of the department and address the signiﬁcant housing shortage in this part of Île-de-France. Motorway crossings will be built, such as the footbridge that will connect the Aquatics Centre in Saint-Denis with the Stade de France, and another in Dugny. The Paris 2024 Olympic pools will have a post-Games legacy, as they will be opened up for use by the residents of three Seine-SaintDenis communes (Pierreﬁtte, Sevran and Bagnolet), where 60 per cent of 11- and 12-year-olds can’t swim. And then there are also the Marville and Aubervilliers pools. I placed a real emphasis on the need to improve accessibility at all the Olympic venues for people with disabilities, because it’s essential for them to be part of the festivities as well. Finally, the environmental strategies of SOLIDEO and the government are just as ambitious. They aim to halve the greenhouse gas emissions at the construction sites by using as much wood as possible; connect venues to the electricity grid to avoid the need for generators; reduce the carbon emissions of the ﬂeet of boats on the Seine; and increase the proportion of daily commuters who choose cycling over other modes of transport – with more than 280km of cycle lanes, plus parking facilities, to date.  1 The Aquatics Centre will become a multi-sports facility for the public after the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 60-line-1\" style=\"top:176px;left:45px\" src=\"/120/static/_content/60-line-1.png\"/>\n        <img id=\"60-quote-1\" class=\"halfScaleC\" style=\"top:84px;left:11px\" src=\"/120/static/_content/60-quote-1.png\"/>\n        <img class=\"halfScale 60-line-1\" style=\"top:176px;left:45px\" src=\"/120/static/_content/60-line-1.png\"/>\n        <img class=\"halfScale 60-title-1\" style=\"top:178px;left:84px\" src=\"/120/static/_content/60-title-1.png\"/>\n        <img id=\"60-img-1\" class=\"halfScaleC\" style=\"top:189px;left:-75px\" src=\"/120/static/_content/60-img-1.png\"/>\n        <img class=\"halfScale 60-sub-1\" style=\"top:626px;left:83px\" src=\"/120/static/_content/60-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg60Anim = new TimelineMax();\n          pg60Anim\n            .fromTo(cOf(\"60-line-1\"), 0.6, {opacity:0, y:40},{opacity:1, y:0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"60-quote-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(cOf(\"60-title-1\"), 0.6, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut}, 1.3)\n            .fromTo(idOf(\"60-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)\n            .fromTo(cOf(\"60-sub-1\"), 0.6, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut}, 1.5)\n        }\n\n        function onPageLeave() {\n          pg60Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ì  games wide open  tony estanguet is a three-time Olympic champion in canoe slalom (2000, 2004 and 2012), three-time world champion (2006, 2009 and 2010), former IOC Member and now President of the Paris 2024 Organising Committee for the Olympic and Paralympic Games.  I  think these Games are going to be special. This is something we’ve been looking forward to, and working on, for such a long time. I’m very aware of the strong links between France and Olympism. I’m truly hoping for an unprecedented event, as our country has everything it needs to stage great, exceptional Games. It’s not just the latest edition of the biggest sporting event on the planet; you can count on us to turn the model from previous editions on its head. I’m dreaming of Games that will go down in Olympic history, as we want to make sure every single moment of the event has as big an impact as possible. Our main driver has been to bring a spectacular, magical quality to the Games, and to make sport accessible to more people at every level: in schools, and in towns and cities, with the “Terre de Jeux 2024” programme and the four million people who have become Club Paris 2024 members. I’ve been calling on my colleagues to be ambitious; although it can be challenging, it’s our job to know our limits and ﬁnd solutions so that we can achieve our highest ambitions for Paris 2024. Our ideal scenario is to have open Games. We need to be bold – to create special moments and make this Games edition unique, with an innovative Opening Ceremony and competitions in venues in the centre of Paris. This will give the athletes a stage to showcase the very best of what they can do, and serve up an unforgettable spectacle and magniﬁcent celebration for TV and online viewers. “Games wide open” means ﬁnding those iconic elements and laying down markers that will make the event different and put a new stamp on the story of the Games. France has consistently left its mark on the history of the Olympics. In 1900, 1924, 1968 and 1992, really amazing things happened in our country. Who can forget the Albertville Opening Ceremony, directed by Philippe Decouﬂé? Truly incredible. The Olympic Games still need to capture the public imagination and make people dream, and also be the driving force in further developing the existing model, by focusing on sustainability, prioritising existing facilities, reducing the carbon impact and combating sedentary lifestyles. It’s important to remember that the World Health Organization says that 80 per cent of"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1  teenagers don’t do enough sport. In a sedentary lifestyle ranking of 140 countries, France came 117th, so a lot of work needs to be done to change the situation. To this end, we’ve worked with the Ministry of National Education to introduce 30 minutes of sport a day into primary schools, to develop the key qualities of respect and self-improvement. And we can bring more sport into the daily lives of people in France. We have 180,000 clubs across the country for a whole range of different sports and disciplines; there’s got to be a club out there for everyone to suit their goals. In a way, Paris 2024 is a combination of all the magic and value of the Olympic Games, and we need to show this. Doing that will be the hardest part, given the unfavourable social and economic context. But we mustn’t shy away from it; we need to use the Games to change the way people think about the beneﬁts of sport for society. This is a once-in-a-lifetime event: it’s a historic occasion and we have to be up to the task. As far as legacy is concerned, we’ve limited the tangible legacy to what is strictly  necessary: accommodation, and transport and sports facilities. There’s only one Olympic pool, but you’ve also got around 20 pools being renovated, and 5,000 local facilities being funded by the government. But the most important legacy for us is the intangible legacy. There are three main focus areas. The ﬁrst is the environment – thinking about the impact the event will have, and how this can be reduced with more responsible attitudes and behaviours: cutting down on plastics, use of transport and construction to ultimately reduce the carbon impact. The second is combating sedentary lifestyles, by leveraging the ecosystem in place: “Terre de Jeux 2024”, clubs, companies, and Olympic and Paralympic Week, in which one million pupils took part this year. It’s about increasing these opportunities to keep showing that sport is vital for all generations. The third key aspect of intangible legacy is inclusion. This is the ﬁrst time that France will be hosting the Summer Paralympic Games. There is clearly still discrimination in our country. The 12 million French people  with a disability have less access to sport, employment and transport. In our own small, modest way, we’re trying to show that the world of sport needs to evolve, so that clubs can welcome more athletes with disabilities. The initiative that has been talked about – to set up 3,000 clubs for people with disabilities – needs to happen; there are currently only a few hundred. We’re organising training sessions for club managers to cater for these athletes, and the government is working to standardise access to sports facilities. We hope we’ve managed to raise some level of awareness among people in France: in staging the Paralympic Games, we need to highlight that we can make progress when it comes to inclusion. If we can do this, the Olympic and Paralympic Games Paris 2024 will have been a success.  1 “ Terre de Jeux 2024” aims to involve all French territories in the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 62-line-1\" style=\"top:176px;left:45px\" src=\"/120/static/_content/62-line-1.png\"/>\n        <img id=\"62-quote-1\" class=\"halfScaleC\" style=\"top:84px;left:11px\" src=\"/120/static/_content/62-quote-1.png\"/>\n        <img class=\"halfScale 62-line-1\" style=\"top:176px;left:45px\" src=\"/120/static/_content/62-line-1.png\"/>\n        <img class=\"halfScale 62-title-1\" style=\"top:178px;left:84px\" src=\"/120/static/_content/62-title-1.png\"/>\n        <img id=\"62-img-1\" class=\"halfScaleC\" style=\"top:189px;left:-75px\" src=\"/120/static/_content/62-img-1.png\"/>\n        <img class=\"halfScale 62-sub-1\" style=\"top:626px;left:83px\" src=\"/120/static/_content/62-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg62Anim = new TimelineMax();\n          pg62Anim\n            .fromTo(cOf(\"62-line-1\"), 0.6, {opacity:0, y:40},{opacity:1, y:0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"62-quote-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(cOf(\"62-title-1\"), 0.6, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut}, 1.3)\n            .fromTo(idOf(\"62-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)\n            .fromTo(cOf(\"62-sub-1\"), 0.6, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut}, 1.5)\n        }\n\n        function onPageLeave() {\n          pg62Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ì  sport has to be inclusive  pierre rabadan is a former rugby union player (sevens and 15s). He was a ﬂanker for the French national team and played for Stade Français for 17 years. In 2020, he was appointed as the Deputy Mayor for Sport and the Olympic and Paralympic Games 2024 at Paris City Hall.  R  ight from the bid phase, we have always focused on how we could evolve the Olympic Games model. The main thing was to preserve the ambition for these Games: to make them innovative and beneﬁcial for the places where they are taking place and for the people who live there; to ﬁnd new audiences; and to attract young people. That is particularly true in Paris, in line with Olympic Agenda 2020 and Olympic Agenda 2020+5, by adapting existing venues and building only what is strictly necessary for the 17 days of competition. For us, there was no question of seeing venues not used after the event, as in the past. In fact, we’ve never made a distinction between what we have to do to ensure excellent Games and the legacy they will leave behind: the two are linked. It’s totally normal and necessary to optimise both infrastructure use and costs. Our aim from the start has been to respect the ﬁnancial commitments of the Games. It’s logical to see how costs can be adjusted and income maximised. That’s true of the Jean Bouin Stadium, which hosts the World Rugby Sevens Series each year. Obviously, I personally am very attached to it, and I’d have liked to see rugby played in the Stade Français ground. But it’s true that moving it to the Stade de France will mean extra revenue, which is also important. That’s also true for the climbing wall, which has been moved from Place de la Concorde to Le Bourget, where it will have a home after the Games. We need to be efficient, and Seine-Saint-Denis has the biggest need to beneﬁt from this event: the Saint-Denis, Marville and Aubervilliers pools will allow more local young people to learn to swim. In a city like Paris with a high population density and few open spaces, we want to continue what we started during the previous term of office, maintaining and developing the city’s 500 sports facilities, improving quality and encouraging people to try new sports. Our aim is also to use sport to achieve better integration with the social and administrative support structures linked to a sports club. Sport has to be inclusive, and we’re not going to shirk our responsibilities. So we’ve used the Olympic Games to speed up a number of investments that we began in 2018, after the capital was elected"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review  63  Issue 120  1  (as host city) in Lima, Peru in September 2017. We’ve done a lot of work on sports facilities throughout the capital, and we’ll have done in 10 years what would have taken 30 if we hadn’t had the Olympic Games. As a result, several dozen locations have beneﬁted from refurbishment work, with some new facilities created. Roofs have been built for sports grounds, plus new 3×3 basketball courts, renovation work on gyms and sports centres, pools, athletics tracks, plus creating new facilities and re-grassing sports ﬁelds. These upgrades wouldn’t have been possible, at least not as quickly, if we hadn’t had the Games. The most well-known venues are the Piscine des Tourelles, which hosted the swimming events in 1924, the Pierre de Coubertin Stadium, the Carpentier Hall and the Vélodrome de Vincennes, all of them French sporting monuments.  The purpose of all this work is to boost the amount of sport played, especially by young people, using more eco-friendly materials than in the past. We still have a lot to do before we host the Olympic Games next year, such as improving the cycle tracks – we have more than 60km of them at the moment, and the public will be able to get to many of the competition venues by bike – but also installing the Olympic lane on the Paris ring road, which will then become a car-sharing lane after the Games. In a patrimonial, historic and ancient city like Paris, we’ll also do our utmost to increase accessibility in the city for people with disabilities. We’re also proud to have achieved something that Jacques Chirac wanted:  1 The Stade de France will be transformed into the Olympic Stadium next year.  to be able to swim in the river Seine. It’s taken years to do it, plus EUR 1.4 billion of investment. Several people have had a tough time with this, as cleaning up the water involves all the communities upstream, in the Marne and Yonne departments, but we’ve managed it. The ﬁrst event in the Seine (marathon swimming) will be the reward for the collective work led by the Prefect of Paris and Île-de-France. The water quality is good, as the tests carried out during the equivalent of the Games period (26 July to 11 August) in 2022 showed that the quality of the river water was excellent on 90 per cent of those days. A pontoon will be set up on the left bank near the Alexandre III bridge for the swimmers to access the water directly. Staging the Games won’t solve all the problems in French sport, but Paris will have played its part. ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 64-title\" style=\"top:44px;left:44px\" src=\"/120/static/_content/64-title-1.png\"/>\n        <img class=\"halfScale 64-sub\" style=\"top:295px;left:455px\" src=\"/120/static/_content/64-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg64Anim = new TimelineMax();\n          pg64Anim.fromTo(cOf(\"64-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"64-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut, onComplete: addContentLinks}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg64Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "the athletesí vIew  ATHLETES FROM FIVE DIFFERENT DISCIPLINES PROVIDE THEIR PERSPECTIVES ON WHY THE OLYMPIC AND PARALYMPIC GAMES PARIS 2024 ARE SET TO BE A GAME-CHANGER"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 65-title-1\" style=\"top:126px;left:55px\" src=\"/120/static/_content/65-title-1.png\"/>\n        <img class=\"halfScale 65-sub-1\" style=\"top:204px;left:56px\" src=\"/120/static/_content/65-sub-1.png\"/>\n        <img id=\"65-img-1\" class=\"halfScaleC\" style=\"top:188px;left:7px\" src=\"/120/static/_content/65-img-1.png\"/>\n        <img id=\"65-img-2\" class=\"halfScaleC\" style=\"top:203px;left:99px\" src=\"/120/static/_content/65-img-2.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:123px;left:54px;width:133px;height:37px;\"><a href=\"https://olympics.com/en/athletes/alistair-brownlee\" target=\"_blank\"></a></div>\n        <div class=\"addContentLinkThree\" style=\"top:160px;left:54px;width:163px;height:37px;\"><a href=\"https://olympics.com/en/athletes/alistair-brownlee\" target=\"_blank\"></a></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg65Anim = new TimelineMax();\n          pg65Anim\n            .fromTo(cOf(\"65-title-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"65-sub-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1.1)\n            .fromTo(idOf(\"65-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(idOf(\"65-img-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 1.3)\n        }\n        function onPageLeave() {\n          pg65Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "alIstaIr brownlee  great brItaIn, trIathlon  olympIan TM  gold  gold  I  look forward to every Olympic Games and Paris is no exception, but I think it's going to be extra special in that it's post-Covid. Tokyo 2020 was an amazing Games, and there was fantastic competition, but there were things missing that are all going to be back with a bang in Paris. We're going to see the whole sporting world return to one city again for those magical two weeks, and I think Paris is going to be an amazing host. I’m really excited to see the crowds.  Athletes want to perform and compete on the biggest stage, and the big crowds and the atmosphere are really special things about the Olympics. When anyone asks me about the most special moments in my triathlon career, they’re all at the Olympic Games: the hype and the build-up, and that incredible feeling as you walk out onto the start line, hearing the roar of people cheering you on. The Paris 2024 triathlon will be in the city centre, in the Seine and on the Champs-Élysées. It will be  accessible and free to view. It will be on routes that people use every day, outside their offices. All of those things will help create amazing experiences for athletes. Triathlon is popular in France, and most of the athletes will have raced in Paris before, so they can expect a really great crowd. Not only that, but seeing the mixed relay on the Olympic programme again is fantastic. I think it's a great event on so many levels: the gender equity, having two men and two women, and its short format – it's really fast and  furious and normally quite close – is great. One of the other unique things about the Olympic Games is being together with thousands of athletes from all over the world: different sports, different countries, completely different backgrounds. That is incredibly special. Paris will really bring back what I genuinely feel is one of the most, if not the most, special parts of the Olympic Games: people coming together to compete peacefully in sporting events from around the world."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 66-title-1\" style=\"top:84px;left:55px\" src=\"/120/static/_content/66-title-1.png\"/>\n        <img class=\"halfScale 66-sub-1\" style=\"top:164px;left:56px\" src=\"/120/static/_content/66-sub-1.png\"/>\n        <img id=\"66-img-1\" class=\"halfScaleC\" style=\"top:148px;left:7px\" src=\"/120/static/_content/66-img-1.png\"/>\n        <img id=\"66-img-2\" class=\"halfScaleC\" style=\"top:160px;left:99px\" src=\"/120/static/_content/66-img-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg66Anim = new TimelineMax();\n          pg66Anim\n            .fromTo(cOf(\"66-title-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"66-sub-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1.1)\n            .fromTo(idOf(\"66-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(idOf(\"66-img-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 1.3)\n        }\n        function onPageLeave() {\n          pg66Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "antoIne brIzard  france, volleyball  olympIan gold  T  he generation of French athletes that I’m part of has the incredible opportunity to compete in a home Games for the ﬁrst time in 100 years. Paris 2024 needs to showcase the great things that France can do and the new ideas it can develop to bring about positive change in sport and major sports events. Until now, it’s fair to say that environmental issues haven’t been a priority in the sporting world, and we know that big sports events unfortunately can’t have a wholly positive impact. But Paris 2024 is the perfect opportunity to set a real example and raise awareness about these kinds of issues, both before and during the event. This includes the things we can do on a daily basis during the Games, like showing we can limit food waste, not using plastic bottles and doing without air conditioning in venues. As an athlete, I’d like everyone taking part in the Olympic and Paralympic Games Paris 2024 to be made aware of at least one thing they can do for the environment, and continue to do that at home after the Games. In my opinion, it would be a mistake to think that the things we can do at our own individual level won’t change anything. I’m not in any way claiming to be a role model and I’m not a specialist on the subject: helping the environment is simply something that I care about as a person and an athlete, so I try to pay as much attention as possible to my actions, as far as I’m able to in my day-to-day life. Today, the sports world needs to evolve, to reduce any harmful impact on the planet as much as it can: this is a transition we have to be part of together, and Paris 2024 needs to lead the way."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 67-title-1\" style=\"top:252px;left:55px\" src=\"/120/static/_content/67-title-1.png\"/>\n        <img class=\"halfScale 67-sub-1\" style=\"top:332px;left:56px\" src=\"/120/static/_content/67-sub-1.png\"/>\n        <img id=\"67-img-1\" class=\"halfScaleC\" style=\"top:314px;left:7px\" src=\"/120/static/_content/67-img-1.png\"/>\n        <img id=\"67-img-2\" class=\"halfScaleC\" style=\"top:333px;left:103px\" src=\"/120/static/_content/67-img-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg67Anim = new TimelineMax();\n          pg67Anim\n            .fromTo(cOf(\"67-title-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"67-sub-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1.1)\n            .fromTo(idOf(\"67-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(idOf(\"67-img-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 1.3)\n        }\n        function onPageLeave() {\n          pg67Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "clarIsse agbÈgnÈnou france, judo  olympIan  sIlver  2 gold  T  here are few better opportunities than a home Games to relay powerful, positive messages around sport and recall its values: courage, humility, mutual cooperation, respect, and the notion that anything is possible if you work at it. For me, it’s important that the Olympic and Paralympic Games Paris 2024 promote these values to young people.  Getting back on the judo mat after giving birth to my daughter [her ﬁrst child] wasn’t easy. After all the changes following my pregnancy, I felt like I was going to have to start again from scratch, and I was asking myself lots of questions: “Will I manage to get back to my peak level? Will I be able to balance my life as an athlete and my life as a mum?”, etc. Personally, I’m lucky enough 2 to have family members there to help me on  a daily basis. It’s thanks to them that I’m able to train in the best possible way and head off to competitions or training camps with my daughter. If I had to send one message to stakeholders in the sporting world, it’s that they should have more conﬁdence in female athletes who want to have children, and look to support them so that they can get back to their peak level. Not everyone appreciates the  strength, determination and resourcefulness that women can have: becoming a mum makes us even more combative, and the values of sport take on even more meaning, because they’re precisely those that we want to pass on to our children through their education. Today, we need more examples that show it’s entirely possible to be both a mum and a high-level athlete. It’s up to sports stakeholders to make this change possible!"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 68-title-1\" style=\"top:64px;left:55px\" src=\"/120/static/_content/68-title-1.png\"/>\n        <img class=\"halfScale 68-sub-1\" style=\"top:144px;left:56px\" src=\"/120/static/_content/68-sub-1.png\"/>\n        <img id=\"68-img-1\" class=\"halfScaleC\" style=\"top:128px;left:7px\" src=\"/120/static/_content/68-img-1.png\"/>\n        <img id=\"68-img-2\" class=\"halfScaleC\" style=\"top:140px;left:99px\" src=\"/120/static/_content/68-img-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg68Anim = new TimelineMax();\n          pg68Anim\n            .fromTo(cOf(\"68-title-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"68-sub-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1.1)\n            .fromTo(idOf(\"68-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(idOf(\"68-img-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 1.3)\n        }\n        function onPageLeave() {\n          pg68Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "arnaud assoumanI  france, para athletIcs  paralympIan  long jump and trIple jump  bronze  gold  2 sIlver  PA RA LYM PIC GAME S  T  bronze  here’s nothing better in an athlete’s career than experiencing a home Games. I had the opportunity to take part in the London Games in 2012 and see Great Britain win four titles in a single evening. The atmosphere was incredible! So obviously, I can’t wait to experience these home Games, especially as inclusion is one of the key themes. The Paris 2024 Games will be inclusive precisely because the Organising Committee wanted to  make this a priority area. From the outset, this intention has been backed up with concrete action, such as Olympic and Paralympic Week: as part of this initiative, as a Paralympic athlete, I receive lots of requests every year to go and speak in schools, to promote sport and raise awareness about diversity. I’ve noticed over the years that inclusion has become a topic of interest for more and more people, which is a good sign.  I ﬁrmly believe that sport is a powerful educational tool that can help spread values such as equality and solidarity. I’d like every young person to be able to identify with an athlete, whether or not they have a disability. Because disability is not an identity, in the same way that skin colour and sexual orientation aren’t. First and foremost, we are athletes, representing our countries in all their diversity. Paris 2024 is trying to break down stereotypes, particularly  in relation to disability, whether through the development of 3,000 clubs for people with disabilities or the visibility that will be given to the Paralympic Games. With 300 hours of Paralympic competition being broadcast live on television, France will be making history: the event has never had this amount of air time before. Personally, I feel sure that Paris 2024’s inclusion initiatives will leave a lasting legacy on the sporting world and wider society."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 69-title-1\" style=\"top:104px;left:55px\" src=\"/120/static/_content/69-title-1.png\"/>\n        <img class=\"halfScale 69-sub-1\" style=\"top:184px;left:56px\" src=\"/120/static/_content/69-sub-1.png\"/>\n        <img id=\"69-img-1\" class=\"halfScaleC\" style=\"top:168px;left:7px\" src=\"/120/static/_content/69-img-1.png\"/>\n        <img id=\"69-img-2\" class=\"halfScaleC\" style=\"top:180px;left:99px\" src=\"/120/static/_content/69-img-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg69Anim = new TimelineMax();\n          pg69Anim\n            .fromTo(cOf(\"69-title-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"69-sub-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1.1)\n            .fromTo(idOf(\"69-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(idOf(\"69-img-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 1.3)\n        }\n        function onPageLeave() {\n          pg69Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "annIIna tIkka (b-gIrl at) fInland, breakIng  judge and athlete role model at  A  lot of people are going to beneﬁt from breaking being at Paris 2024. It’s really exciting and important for the sport. More kids are coming to breaking, because there is more visibility and it’s taken more seriously, and the number of people who do it is going to grow – it’s already growing! Training and coaching have also become more organised, which also helps with things like preventing injuries. And, with only the top 16 guys and top 16 girls [in the world], the quality of breaking in Paris is going to be really high. The fact that Paris 2024 will have gender parity is really positive. When I started breaking, it was quite a masculine world and it was rare to see a female judge; only a few girls made it to the top level because of a lack of opportunities. We’ve seen a big change during the past few years, and the attitude from organisers has changed. Now we’re seeing the level of girls’ breaking going so much higher than before, because of the trust and the opportunities, and more girls are getting into breaking because they see what they can achieve and what it can be. Being a mother has presented challenges as well. I’m lucky that in my country we have good childcare that is affordable, so I can have the time to be able to focus on my sport. Without accessible childcare, it’s really hard to combine sport and being a parent. What’s also difficult is that I feel that, when you become a mother, the assumption is that you won’t get back to your sport. I know that some female athletes struggle with funding and sponsors, because you have to start proving yourself again, and it’s hard to get back to where you were without support. I feel this is something that still needs some kind of change of attitude."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 70-title\" style=\"top:222px;left:42px\" src=\"/120/static/_content/70-title-1.png\"/>\n        <img class=\"halfScale 70-sub\" style=\"top:394px;left:43px\" src=\"/120/static/_content/70-sub-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:408px;left:107px;width:152px;height:13px;\"><a href=\"https://olympics.com/en/news/forefront-of-womens-coaching-myriam-fox-jerusalmi\" target=\"_blank\"></a></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg70Anim = new TimelineMax();\n          pg70Anim.fromTo(cOf(\"70-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"70-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n          setTimeout(function(){\n            addContentLinks();\n          },1900)\n        }\n\n        function onPageLeave() {\n          pg70Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "vIsualIsIng a new future for female coaches AUSTRALIAN CANOEING COACH AND TWO-TIME OLYMPIAN MYRIAM FOX-JERUSALMI DISCUSSES THE SIGNIFICANCE OF GENDER PARITY AT THE OLYMPIC GAMES PARIS 2024 AND THE FUTURE FOR FEMALE COACHES. BY CHARLI CASEY  T  here’s plenty to get excited about ahead of the Olympic Games Paris 2024. An historic Opening Ceremony along the river Seine, open to local residents, spectators from afar and, of course, 10,500 athletes. New sports, with events taking place across the city, outside of the traditional stadium setting. Daily celebrations for the athletes in the Champ-de-Mars under the Eiffel Tower. But there is one thing in particular that is inspiring Myriam Fox-Jerusalmi. Of the competing athletes, 5,250 will be women and 5,250 will be men. This will make Paris 2024 the ﬁrst Olympic Games in history to reach full gender parity. “Paris 2024 is going to be different on so many levels to the Games that have come before,” she says. “The Games are going to inspire so many young girls and boys. The fact that they will see a balanced number of male and female athletes competing in each sport may help them to follow their own sporting dreams.  Myriam Fox-Jerusalmi has coached daughter Jessica to four Olympic medals."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1  “Paris will be sending a message that if there’s a sport you want to do, do it; if a young girl watching wants to become a boxer, or a young boy wants to try a more artistic sport, it should feel normal to them.” As part of the drive for equality, the number of mixed gender events has grown from 18 to 22, and 28 out of the 32 sports on the Olympic programme will be fully gender balanced. This has been made possible by initiatives led by the IOC and delivered in partnership with Paris 2024, International Federations, National Olympic Committees and broadcasters, among other key Olympic Movement stakeholders. “This is how it should be. Gender equality should be everywhere,” Fox-Jerusalmi says. “We should be giving women the same opportunities that we give men from the very start, so that at the highest level, equality is then completely normal.” However, while great progress has been made with gender-equal participation among athletes at the Olympic Games, the underrepresentation of women among elite coaches remains one of the biggest challenges across the Olympic Movement. At Tokyo 2020, only 13 per cent of coaches  across 33 sports were women. The IOC responded with WISH – the Women in Sport High Performance Pathway – which is a bespoke four-year programme designed to equip around 100 women to coach at the elite level and is backed by USD 1 million in Olympic Solidarity funding.  2  With decades of experience to reﬂect on, Fox-Jerusalmi admits that coaching at the elite level is demanding, time-consuming and, often, far from glamorous. She recognises that courage and belief were essential in helping her to step into an environment where few women had walked before, but sees particular room for improvement in meeting the needs of female coaches with, or wanting to have, children. She identiﬁes the practicalities of organising childcare while away for extended periods as particularly challenging and suggests ways support could be improved. “In high-performance sport, we don’t want coaches to be worrying about the time they’ll need to spend with athletes abroad for competition,” she explains. “But when you have children, it’s impossible not to consider that. It’s hard unless you have the support of those around you. “The nature of our sport is not easy. The schedule is really heavy. If you need to commit to three or four weeks back-to-back, it’s extremely difficult if you have a young family, and especially so if you live outside of Europe and can’t travel home for a few days before returning to camp. “Sports organisations need to ﬁnd a way of providing back-up. This could be sending two coaches instead of one, or perhaps allowing women to bring their children along at some stage. I’m seeing this support being provided to female athletes – with my organisation,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 73-quote\" style=\"top:108px;left:43px\" src=\"/120/static/_content/73-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg73Anim = new TimelineMax();\n          pg73Anim.fromTo(cOf(\"73-quote\"), 0.8, {opacity:0, x:20},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg73Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Review  73  Issue 120  “We should give women the same opportunities we give men from the very start, so equality is completely normal” myrIam fox-jerusalmI  Paddle Australia, one of the sprint girls has had a baby and I’m sure they’re going to act on her needs as a new mother – but it’s not yet there for coaches.” While appreciating that the barriers female coaches feel will ultimately be very personal, Fox-Jerusalmi also emphasises the role of guilt, which many women grapple with when potentially missing key moments with their children as they build their career at the elite level. “If you have a demanding job, some mothers feel torn between ‘Am I missing seeing my kids grow up?’ and ‘I'm okay to do that.’ There’s always guilt with what you do,” she says. “For me, I remember thinking that I had no guilt, in a sense, because I was giving so much pleasure to my parents who could spend time with their grandchildren for three weeks while I was away, and I knew they were all so happy. It was a compromise that worked for us. “But I was once ﬂying home from a tour in South America. I turned on my phone when I landed, and I received a message to say that one of my kids was in hospital with a broken arm. I left everything at the airport; I ran to the hospital. It’s so strange that these things always seem to happen when you’re away, and these are the moments you can never get back.” Motherhood has long been an important topic for Fox-Jerusalmi. When she chose to have a baby between competing for France at the Olympic Games Barcelona 1992 and Atlanta 1996, it was an uncommon decision at the time and uncertainty if she would return to  1 Fox-Jerusalmi shows Jessica her bronze medal from Atlanta 1996. 2 On the Olympic podium just two years after becoming a mother. 3 Celebrating gold with Jessica in the C1 canoe slalom at Tokyo 2020.  the highest level of her sport. Despite winning bronze in the K1 slalom in Atlanta, two years after the birth of her ﬁrst daughter, it then took time for a door into coaching to open. It was ahead of Sydney 2000 that her coaching career slowly began to fall into place. The Australian national canoeing team offered Fox-Jerusalmi’s husband, Richard Fox, who competed for Great Britain in canoe slalom, a position in the host city. Now with two young children, they relocated as a family, with Fox-Jerusalmi leaving behind a job in her home city Marseille, in her native France. She started coaching for the national team as a volunteer with a lighter schedule before joining full-time from 2004, working with the senior women while keeping an eye on the younger girls coming through. “The national team needed help with some of the coaching. I did a few hours as an unpaid volunteer, and everybody knew that my priority was my children,” reveals Fox-Jerusalmi. “My kids would come with me and everybody was happy. It was a win-win, because while I was only giving a little of my  3  time, I had lots of experience, and they were happy to have me on board.” Of the younger girls whose progress Fox-Jerusalmi monitored closely was her daughter, Jessica Fox, who has followed in her parents’ footsteps. Under her mother’s guidance, Fox has gone on to become one of the most successful canoe slalom athletes of all time, with 12 world titles. She counts four Olympic medals among her incredible achievements, including one gold, and she’ll be targeting more success in Paris. Notably, Fox’s gold came at Tokyo 2020 in the ﬁrst-ever women’s C1 canoe slalom event to feature on the Olympic programme. Before Tokyo, women could only compete in kayak slalom. Fox-Jerusalmi was instrumental in instigating this change, having long sought to develop the sport at the elite level for women, and she appreciates that growing up at a time when campaigns around gender equality were becoming commonplace may have inﬂuenced her daughter's determination to reach the top. “When Jess was around 13, we were strongly ﬁghting for gender equity within paddling,” she explains. “She was a part of it,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "and she could see the instinct that we had to make improvements for female athletes in our sport. “My husband, Richard, has been especially supportive. He has always said, ‘Yes, why not? Of course we’re going to eventually arrive at a point where women will be given the same opportunities as men.’ And we’ve got there. It’s taken time, but we’re going to see it in Paris.” Going forward, an important focus is exposure. In 2018, the IOC updated its Portrayal Guidelines in line with the Gender Equality and Inclusion Objectives for 2021-2024, as it sought to improve the visibility of sportswomen through the media and encourage more positive and diverse role models to be given a fair chance to shine in the spotlight. As we close in on 2024, Fox-Jerusalmi is conﬁdent we’ve moved ﬁrmly in the right direction. In Paris, young girls around the world will see more female athletes than ever compete on the largest global sporting stage of all, and she praises the approach the IOC has taken in making gender equality a reality on the ﬁeld of play. To expand on this progress, over the next decade, she views Paris as the potential catalyst for inspiring lasting changes off the ﬁeld of play. “For Brisbane 2032, could we see that teams are told that they can only compete if they have an equal number of accredited male and female coaches?” she asks. “It’s difficult to know if that would work and what the reaction would be, but it’s an important consideration, because at some point it needs to be a given that each team will have a female coach on board. “The more exposure we can provide the next generation with successful female coaches at the elite level, the more girls will grow up viewing coaching as a realistic career pathway. We need girls to visualise that future for themselves, and conﬁdently think, ‘I can do this. I’ve seen plenty of women coaches come before me, and this is what I want to do, too’.” ■  1 Fox-Jerusalmi won the IOC Coaches Lifetime Achievement Award in 2022. 2 In training with Jessica at Penrith Whitewater Stadium in Sydney, Australia.  1  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Get Ready For The Best"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 76-title\" style=\"top:161px;left:42px\" src=\"/120/static/_content/76-title-1.png\"/>\n        <img class=\"halfScale 76-sub\" style=\"top:351px;left:43px\" src=\"/120/static/_content/76-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg76Anim = new TimelineMax();\n          pg76Anim.fromTo(cOf(\"76-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"76-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg76Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "76  Opinion  opinion  Hosting the Olympic Games is uplifting As Paris celebrates one year to go until the Olympic Games 2024, Sir Hugh Robertson – Chair of the British Olympic Association and Minister for the Olympics in 2012 – reﬂects on how organisers were able to ensure the Games delivered a lasting legacy for British sport  Sir Hugh Robertson is Chair of the British Olympic Association. Previously, he was the British Minister for Sport and the Olympics, responsible for the delivery of the Olympic Games London 2012, overseeing all aspects of the budget, construction, operational management and legacy.  T  he one-year-to-go milestone is a hugely significant moment for any Olympic Games. It’s a moment that really focuses the mind. And it’s a moment when you realise that this incredible event, which you’ve been working towards for so many years, is now suddenly very close indeed. For those of us involved in London 2012, that final year was a blur of testing, testing and testing. We had to be absolutely sure that all the facilities we built worked, that we could move a million people into and out of the Olympic Park safely, and that the public transport links were going to work. We soon discovered that people left the stadia in different ways to how the computer simulations had planned for them to leave, because human beings are human beings and they work in different ways. But we only discovered that by testing. One thing we couldn’t test was the long-term legacy that we hoped to create. There are no guarantees, but we didn’t want to leave anything to chance. We were absolutely clear from a very early stage that we had to plan a legacy at the same time as we were planning the Games. The phrase we used was that legacy had to be built into every stage of Games-time planning, and we sought to define legacy in five key areas. There was the legacy for the economy, in terms of encouraging trade, inward investment and tourism, and the economic  boost this would bring. There was the legacy in terms of regeneration, and what the Games meant for the area around Stratford. There was the legacy in terms of community, and how the Games could bring people together and inspire a generation. There was the legacy in terms of what hosting the Paralympics could do for promoting inclusivity and changing attitudes towards people living with disabilities. And then there was the sporting legacy, and what the Games could do for British sport. It's incredible to go back to Queen Elizabeth Olympic Park now and recall all those historic moments for Team GB. Looking at the Olympic Stadium, you can’t help but think of “Super Saturday”, which delivered perhaps the greatest night in the history of British athletics. Then there’s the Velodrome, which roared day after day with medal-winning performances for the host nation. And there’s the riverbank, where crowds gathered around giant screens to cheer as medals were won at venues throughout London and beyond."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 77-quote\" style=\"top:501px;left:43px\" src=\"/120/static/_content/77-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg77Anim = new TimelineMax();\n          pg77Anim.fromTo(cOf(\"77-quote\"), 0.8, {opacity:0, x:20},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg77Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "77  1  “The Olympic Games can redefine the way that the rest of the world looks at you as a country” sIr hugh robertson  There are other memories, too. Like how this was all once the largest industrial wasteland inside the M25 motorway. It’s hard to imagine now, when you see the families walking through the park, the bustling shopping centre, and the commuters rushing in and out of the station. But it is a fantastic example of how sport can be used to regenerate an area and how it can be integrated into people’s lives to their benefit. Anybody who’s lucky enough to rent or own a flat in Stratford now has this wonderful green space on their doorstep. They can go cycling and running. There’s a swimming pool they can use. There’s a Premier League football stadium.  There are hockey pitches and tennis courts and all the facilities at the Copper Box. It’s been utterly transformational. This is where the sporting legacy goes beyond the high-performance level. Obviously, we’re incredibly proud of those elite-level successes, particularly the fact that Great Britain won more medals at Rio 2016 than we did on home soil at London 2012. That’s never been done by a host nation before and is an extraordinary achievement. Great Britain’s reputation for hosting major sports events was also given a huge boost by London 2012, with the country subsequently staging a succession of major global and continental events in the decade since the Games. But the sporting legacy goes beyond that. You also have the legacies to community and school sport. In preparing for London 2012, we ran a programme called “Places People Play”, which was the cornerstone of our grassroots legacy, helping more people of all ages and abilities to play sport. This included  upgrading local sports clubs and facilities, investing in multisport facilities, and recruiting and training thousands of sports leaders to organise and lead grassroots sporting activities. All of this extended far beyond the new facilities that were built in the Olympic Park, which are all now used by the community as well – from the Aquatics Centre, VeloPark and Copper Box to the temporary venues that were dismantled and moved to other locations after the Games. All of these sporting legacies are inextricably linked to one another – from the elite level to local communities. When we were preparing for London 2012, we always used to say, “There’s no point trying to inspire young people through sport if you don’t have good role models for them to follow.” That’s why the success of athletes like Dame Jessica Ennis and Sir Chris Hoy in London was so important. But to build on that success, you also need to have the right facilities, and the right opportunities for people to participate at the grassroots level. Inspiration is not enough by itself. That’s why it’s so important to be precise about how you are going to define that legacy, how you are going to realise it, and how you are going to judge the success of it. For London 2012, we had our five pillars of the economy, regeneration, sport, community and disability, but we perhaps missed a significant one, which is how hosting the Olympic Games can give a host country an undeniable lift. It can change the way people feel about a city and redefine the way that the rest of the world looks at you as a country. Paris and the whole of France will find that out next year. I remember our final year being full of little bumps in the road, but once the Games start, it is all about the sport and that is all anyone will be focused on. After that, Paris will be able to bask in the glow of what I am sure will be a fantastic, era-defining Olympic Games. ■  1 The success of athletes such as Sir Chris Hoy played a pivotal role in the sporting legacy of London 2012."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 78-title\" style=\"top:161px;left:42px\" src=\"/120/static/_content/78-title-1.png\"/>\n        <img class=\"halfScale 78-sub\" style=\"top:297px;left:43px\" src=\"/120/static/_content/78-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg78Anim = new TimelineMax();\n          pg78Anim.fromTo(cOf(\"78-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"78-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg78Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "78  Opinion  opinion  Changing the face of a city Bill Morris considers how the Olympic Games, and other mega events, can have a positive and long-term impact on the host city  Bill Morris was the Director of Ceremonies, Culture, Education and Live Sites for London 2012. He has been a Senior Advisor to the IOC for the last decade. He is a Trustee of Spirit of 2012 and recently completed a Masters Degree in Sustainable Urban Development at the University of Oxford. The ﬁndings of the UK National Inquiry into the social impact of events can be found at www.spiritof2012.org.uk. A copy of Morris’s Oxford research can be accessed at the Olympic Studies Centre.  A  nticipation and trepidation – in equal measures – pump through my synapses in preparation for any visit to London 2012’s Olympic Park. Why such strange chemistry prompted by mundane journeys across the Central Line train to Stratford over the last decade? The reasons are both deeply personal and now academic. In each case they relate to long-term impacts of the Olympic Games on this world city, and any city as it addresses the profound issues of sustainable urban development. For thousands who worked on the London Games (and, I suspect, any Olympic Games), our experiences – challenging, exhausting and euphoric – are seared forever into our DNA, life-changing, career-defining, and deeply engrained with the physical space of the Olympic Park. So it is that with every return to the stadium that hosted Danny Boyle’s extraordinary Opening Ceremony, the sporting triumphs that followed and an even more remarkable festival of benign, neo-national pride, I worry. If, emerging from Stratford Station into the Park, I were ever to find it windswept, unloved, lonely and gathering tumbleweed, imagine the personal grief – the deflation and rupture of so much London 2012 human capital. If that’s a profoundly human emotional equation, it’s also the capsule version of proper evaluation of the lasting impact of an Olympic Games on its urban community – an evaluation I have been fortunate to explore in recent years. An Oxford University post-graduate research project, and my role as a commissioner on the United Kingdom’s National Inquiry  into the social impact of events, provided the vehicles to ask if global mega events cannot just be more sustainable, but also spearhead social and physical sustainability for their host communities. For Oxford University I took the Games of London and Rio as primary case studies, while also running a rule over plans for Paris, LA and Brisbane. Mixed method research, grounded in a review of extant evidence, featured 36 in-depth interviews with leaders from all perspectives of hosting, mounting and evaluating Olympic Summer Games. In parallel, the National Inquiry (sponsored by “The Spirit of 2012 Trust”) spent 14 months exploring the impacts of events, large and small in all corners of the UK, taking witness from participants, communities, experts and academics. It looked not just at sporting events, but the UK’s “City of Culture” programme and galvanising national events such as the Royal Jubilee celebrations. The question in common was how to optimise positive lasting value from the high-octane catalyst of all mega events and, particularly the biggest of all, the Olympic Games. All of which takes me back to London’s East End. As the train doors open on a vista of the Queen Elizabeth Olympic Park (as it is now known), there is a sea of diverse humanity – shoppers crowding the vast 1 mall; office workers, armed with oat milk lattes, heading for the freshly gleaming corporate towers; youthful urbanistas on a beeline for the new galleries and cultural centres; families – picnics in hand – eyeing up the prime spots among the wildflower meadow parkland; and athletes, fans and volunteers on well-trodden paths to famous sports venues. Once again, my worries are groundless. The park is humming with life, cherished and punctuated with cranes that promise yet more development. The 2012 urban planners located this new community at the nexus of a remarkable public and active transport system, regenerated long-abandoned and deeply poisoned brown-field sites, built social as well as market housing (much of it for rent), mixed employment, education, retail, technology, culture, sport and health around London’s first major urban park for decades. Most"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 79-quote\" style=\"top:472px;left:43px\" src=\"/120/static/_content/79-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg79Anim = new TimelineMax();\n          pg79Anim.fromTo(cOf(\"79-quote\"), 0.8, {opacity:0, x:20},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg79Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "79  2. The Olympic Games (and other mega events) cannot be a panacea, so pick a realistic shortlist of major sustainability targets (public health, climate change/ net-zero, public transport, social equity or others drawn from the United Nations’ Sustainable Development Goals, all spring to mind) and forge consensus around the main focus. 3. Build governance structures for the long term, balancing and integrating the needs of event delivery with long-term planning and social cohesion. 4. Ensure that funding streams and political consensus are in place for the long haul – not just the event. 5. Don’t forget that the main event has to be successful to drive any lasting impacts. Long-term planning should help this too. 1  “Don’t forget that the main event has to be successful to drive any lasting impacts” bIll morrIs  (though not all) observers and academics concur that the QE Park is working and offers a model of urban sustainability. Sadly this is not the common media image associated with all major event impacts, so what are the lessons to be drawn from London’s QE Park? Firstly, it is the result of a clear, long-term vision. At the turn of the new millennium, London’s Mayor only supported a London Olympic bid because he saw the opportunity for a 30-year regeneration programme for the city’s impoverished East End. The need was profound and he judged that hosting a global mega event was his only way to secure commitment and resources. Next was the requirement for appropriate, dedicated governance structures, exhibiting clear ownership and  accountability for the project – not just in first-phase construction, but for long-term development. The Olympic Development Authority and LOCOG (the Games Organising Committee) ran the first shift, handing over neatly, post-Games, to the London Legacy Development Corporation, which remains as the planning and oversight body more than a decade later. Built into the structure was a model that provided hypothecated funding and a modicum of insulation from the hurly-burly of party political vacillation. Based on this and other testimonies in my own research and the findings of the UK National Inquiry, what advice should be shared with future Games and other mega-event hosts? 1. Look well ahead to the long-term sustainable development needs of your community (whether physical, social or economic) and carefully assess the extent to which event hosting could be the catalyst you need. If so, see the Games not just as an event, but as the pivot point for a 20- or 30-year sustainable development programme.  My research was independent of the IOC, but it bodes well that the Olympic Movement is showing a lead by adopting many of these principles not just in advice to future potential hosts, but in its own vision and planning for future Olympic Games. Seeing such events carefully curated as potent catalysts for sustainable communities is not only good news for cities, but will facilitate a further era of Olympic success and more sustainable Games. By way of post-script, sharp-eyed readers may have noticed a gap in my musings – the absence of the word “legacy”. While the concept around legacy has never been more pertinent, there was consensus among interviewees in my research that the term itself is beyond its “use-by date” – not reflective of the extended planning period before as well as after Games, and too often deployed as ill-defined, post-hoc, virtue-signalling. Discuss… And while that debate begins, I will gird my emotional loins for the next visit to London’s QE Olympic Park. ■  1 London's Queen Elizabeth Olympic Park, pictured here 10 years after hosting the 2012 Games, remains a hive of activity."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 80-title\" style=\"top:83px;left:42px\" src=\"/120/static/_content/80-title-1.png\"/>\n        <img class=\"halfScale 80-sub\" style=\"top:147px;left:43px\" src=\"/120/static/_content/80-sub-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:240px;left:42px;width:202px;height:115px;\"><a href=\"https://library.olympics.com/Default/search.aspx?SC=CATALOGUE&QUERY=Coubertin+autographe&QUERY_LABEL=#/Search/(query:(InitialSearch:!t,Page:0,PageRange:3,QueryString:'Coubertin%20autographe',ResultSize:-1,ScenarioCode:CATALOGUE,SearchContext:0,SearchLabel:''))\" target=\"_blank\"></a></div>\n        <div class=\"addContentLinkThree\" style=\"top:240px;left:257px;width:92px;height:115px;\"><a href=\"https://library.olympics.com/Default/doc/SYRACUSE/2954165/tokyo-2020-official-report-the-tokyo-organising-committee-of-the-olympic-and-paralympic-games\" target=\"_blank\"></a></div>\n        <div class=\"addContentLinkThree\" style=\"top:240px;left:475px;width:82px;height:115px;\"><a href=\"https://library.olympics.com/Default/doc/SYRACUSE/2953854/olympic-sport-organisations-in-times-of-crisis-and-change-guide-for-strategic-management-and-good-go\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLinkThree\" style=\"top:823px;left:195px;width:134px;height:13px;\">\n          <a href=\"mailto:studies.centre@olympic.org\"></a>\n        </div>\n\n        <div class=\"addContentLinkThree\" style=\"top:823px;left:342px;width:195px;height:13px;\">\n          <a href=\"https://www.olympics.com/ioc/olympic-studies-centre\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLinkThree\" style=\"top:836px;left:252px;width:110px;height:13px;\">\n          <a href=\"https://www.facebook.com/OlympicStudiesCentre/\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLinkThree\" style=\"top:836px;left:377px;width:100px;height:13px;\">\n          <a href=\"https://library.olympics.com/default.aspx?_lg=en-GB\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg80Anim = new TimelineMax();\n          pg80Anim.fromTo(cOf(\"80-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"80-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n          setTimeout(function(){\n            addContentLinks();\n          },1900)\n        }\n\n        function onPageLeave() {\n          pg80Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "80  Olympic Studies  olympic studies The latest book reviews from the IOC Olympic Studies Centre – your source of Olympic knowledge  coubertIn autographe: 1915−1937  Twenty years after the publication of Coubertin autographe – Tome I (1889-1915) comes Tome II (1915-1937). This latest collection of letters and manuscripts by Pierre de Coubertin reveals new information and sheds light on the last two decades of his life: the IOC’s move to Lausanne on 10 April 1915, the Great War, his farewell to the Olympic Movement, and his ﬁnal years right up until his death on 2 September 1937. Jean Durry’s aim remains the same: to make Coubertin’s writings widely accessible and shine a light on this extraordinary man. This volume incorporates responses of Coubertin’s interlocutors more broadly and includes numerous additional documents that signiﬁcantly add to the letters and manuscripts hitherto published. Moreover, Durry puts in context the places, the actors and the different circumstances, and revives many an unknown or forgotten fact.  author: Jean Durry published: with the support of the IOC, 2023, 484 pages, in French.  tokyo 2020 offIcIal report The official report of Tokyo 2020 consists of three volumes and a documentary ﬁlm. The ﬁrst volume, which is the main part of the report, is a comprehensive description of the efforts of the Organising Committee and related organisations in preparing and organising the Games. Chapter 1 describes the context of the Games, symbolised by the postponement, as well as their philosophy and characteristics. Chapter 2 describes in detail all the initiatives implemented to create a legacy around different themes such as competition venues and facilities, Games management, the Olympic Torch Relay, ceremonies, marketing and ticketing, and ﬁnances. The second volume is mainly devoted to photos, both of the highlights of the competitions and the Torch Relay, and the third volume has information about the organisational structure of the Organising Committee.  olympIc sport organIsatIons In tImes of crIsIs and change: guIde for strategIc management and good governance In response to the new and complex challenges facing society, National Olympic Committees (NOCs) must act strategically to keep up with the changing environment and draw the right conclusions from the changes taking place. Developed in close collaboration with 11 NOCs, the European Olympic Committees and EOC EU Office, this is a ground-breaking strategic management guide for Olympic sports organisations. It aims to help organisations identify changes and provide tools to implement them, then turn the inherent challenges and threats into opportunities. The authors provide numerous examples and applications of good practice, recommendations and training sessions through workshops and case studies.  edited by: The Tokyo Organising Committee  authors: Holger Preuß, Christiana  of the Olympic and Paralympic Games published by: The Tokyo Organising Committee of the Olympic and Paralympic Games, 2022, in English and Japanese.  Schallhorn, Norbert Schütte published by: Academia Verlag, 2022, ISBN 9783985720637 (print), 9783985720644 (ebook), 246 pages, in English.  fInd out more For historical, factual and academic research, library resources and book loans, visit the Olympic World Library or contact us. studies.centre@olympic.org olympics.com/ioc/olympic-studies-centre OlympicStudiesCentre library.olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 82-title\" style=\"top:97px;left:42px\" src=\"/120/static/_content/82-title-1.png\"/>\n        <img class=\"halfScale 82-sub\" style=\"top:162px;left:43px\" src=\"/120/static/_content/82-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg82Anim = new TimelineMax();\n          pg82Anim.fromTo(cOf(\"82-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"82-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg82Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "82  Obituaries  obItuarIes We remember Olympians and ﬁ gures from the Olympic Movement who have passed away  bernard lapasset Former World Rugby Chairman who campaigned for rugby’s Olympic return Bernard Lapasset, the former Chairman of World Rugby, has died at the age of 75. Lapasset also served as President of the French Rugby Federation from 1991 to 2008 and successfully campaigned for rugby’s return to the Olympic Games. After his second term at the helm of World Rugby in 2016, he focused his efforts on Paris’s candidature to host the Olympic Games 2024, working alongside Tony Estanguet. Since 2018, he had been Honorary President of the Paris 2024 Organising Committee. Lapasset received the Olympic Order in 2022 for his contribution to the Olympic Movement.  pat mccormick Four-time Olympic diving champion Pat McCormick has died aged 92. The American won both the springboard and platform events at the Olympic Games Helsinki 1952 and repeated the feat four years later at the Olympic Games Melbourne 1956. In doing so, she became the ﬁrst diver to sweep both the 3m and 10m events at consecutive Olympic Games – an accomplishment that was later matched by the USA’s Greg Louganis at Los Angeles 1984 and Seoul 1988.  eli wolff Eli Wolff, a passionate educator, athlete, activist and advocate for sport as a tool for social good, has died aged 45. As well as being a member of the United States Paralympic Soccer Team at the 1996 and 2004 Paralympic Games, Wolff ’s many achievements included helping to establish the International Day of Sport for Development and Peace. He also helped ensure sport was included in the United Nations Convention on the Rights of Persons with Disabilities.  ralph boston Three-time Olympic long jump medallist Ralph Boston has died aged 83. Boston won gold at the Olympic Games Rome 1960, before claiming silver in 1964 and bronze in 1968 to earn a complete set of Olympic medals. The American also set six ratiﬁed world long jump records – more than any other man in history – between 1960 and 1965. His ﬁrst record came in August 1960, when he leapt 8.21m to break the mark set by the great Jesse Owens 25 years earlier."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.png",
    "zoom": null,
    "content": "\n        <div class=\"addContentLinkThree\" style=\"top:120px;left:63px;height:23px;width:114px;\">\n          <a href=\"https://www.youtube.com/watch?v=CZsH46Ek2ao \" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": "Olympic Review  83  Issue 120  bob richards Bob Richards, the only man to have won two Olympic pole vault titles, has passed away at the age of 97. The American won gold at both the 1952 and 1956 Olympic Games, following a bronze medal at the Olympic Games London 1948. His three medals make him the most decorated male Olympic pole vaulter ever. Richards was elected to the US Olympic Hall of Fame in 1983 and the United States National Track and Field Hall of Fame in 1975.  dick fosbury Legendary US high jumper who pioneered a ground-breaking technique Dick Fosbury, Olympic gold medallist and high jump pioneer, has passed away aged 76. Fosbury was the ﬁrst athlete to jump backwards over the bar – a ground-breaking technique that became known as the “Fosbury Flop”. In winning gold at the Olympic Games Mexico City 1968 – clearing a new Olympic record of 2.24m – the American revolutionised the event, with high jumpers still using his technique today. Fosbury remained active within the Olympic and Paralympic Movements following his athletic retirement, previously serving as Vice-President of the United States Olympic and Paralympic Association, as well as the President of the World Olympians Association.  shozo sasahara Japanese Olympic gold medallist Shozo Sasahara has died aged 93. As a freestyle wrestler, Sasahara won gold in the featherweight category at the Olympic Games Melbourne 1956, where he was also ﬂagbearer for the Japanese team at the Opening Ceremony. Sasahara was also crowned world champion two years before his Olympic triumph, and his achievements saw him move into coaching once his own competitive career was over. Among his students was Osamu Watanabe, who won gold in the same event as Sasahara at the Olympic Games Tokyo 1964. From 1989 to 2003, Sasahara was President of the Japan Wrestling Association, while he also served as Vice-President of United World Wrestling (UWW) and was later named its Honorary Vice-President. In 2006, he was inducted to the UWW International Wrestling Hall of Fame.  tori bowie Tori Bowie, the 2017 world 100m champion and multiple Olympic medallist, has died at the age of 32. Alongside her individual world title, Bowie also formed part of the USA’s gold medal-winning 4×100m team at the 2017 World Championships in London (Great Britain), and claimed an Olympic medal treble at Rio 2016, winning gold in the 4×100m, silver in the 100m and bronze in the 200m. She also competed in the long jump, ﬁnishing fourth in the women's event at the 2019 World Championships in Doha (Qatar)."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 84-title\" style=\"top:85px;left:147px\" src=\"/120/static/_content/84-title-1.png\"/>\n        <img class=\"halfScale 84-sub\" style=\"top:139px;left:145px\" src=\"/120/static/_content/84-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg84Anim = new TimelineMax();\n          pg84Anim.fromTo(cOf(\"84-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"84-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg84Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "84  The last word  breaking new ground They may be separated by a century, but the Olympic Games Paris 1924 and 2024 will both go down in history for setting many historic ﬁrsts  “Citius, Altius, Fortius” used in an Olympic Games context  Built an Olympic Village  Formalised the athletes’ oath Broadcast the Games live on the radio  Implemented the raising of three flags at the Closing Ceremony  Used marked lanes in swimming events  IOC  50%  50%  Equal number umber of participating cipating male and d female athletes  Host nation  Next host nation  Breakingʼs debut de on the Olympic Olympi programme  A spe specially made Media Village  Opening Ceremony to be held outside the Olympic Stadium  Events open to the general public (in athletics and cycling)  Formalised competition rules and techniques  Engaging overseas territories and communities"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 84,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg85.png",
    "zoom": null,
    "content": "\n        <div class=\"addContentLinkThree\" style=\"top:846px;left:542px;height:23px;width:150px;\">\n          <a href=\"https://samsung.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 85,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg86.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THANKS TO OUR WORLDWIDE OLYMPIC PARTNERS"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function pg16_gallery(index) {\n        Publish.openGalleryTwo([[\n          '1924-1.jpg',\n          '1924-2.jpg',\n          '1924-3.jpg',\n          '1924-4.jpg',\n          '1924-5.jpg',\n          '1924-6.jpg',\n          '1924-7.jpg',\n          '1924-8.jpg',\n          '1924-9.jpg',\n          '1924-10.jpg'\n        ], \n        index])\n      }\n\n      function pg52_gallery(index) {\n        Publish.openGalleryTwo([[\n          '2024-2.jpg',\n          '2024-3.jpg',\n          '2024-4.jpg',\n          '2024-5.jpg',\n          '2024-6.jpg',\n          '2024-7.jpg',\n          '2024-8.jpg',\n          '2024-9.jpg'\n        ], \n        index])\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-G990GHPD5Y" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RkWL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WAN5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q5L0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0bbe74eb7d264cc615e8.js